import { jsx as F, jsxs as J } from "react/jsx-runtime";
import { b as Re, c as pu, d as Oe, e as q, f as Ne, g as Ze, h as m, i as Ue, j as Me, k as qe, l as He, m as Ge, n as _e, o as We, p as Ye, q as Xe, r as Je, s as Qe, t as u4, u as e4, $ as t4, a as r4 } from "../FileTrigger-QWt0qitW.js";
import k, { useState as z, useEffect as _, useContext as a4, useMemo as Du, useRef as W, createContext as Bu, forwardRef as n4 } from "react";
import { Text as Q } from "./Text.js";
import { Icon as o4 } from "./Icon.js";
import { c as i4 } from "../index-Cu0xwYjD.js";
function l4(u, e) {
  let { id: t, "aria-label": r, "aria-labelledby": n } = u;
  return t = Re(t), n && r ? n = [
    .../* @__PURE__ */ new Set([
      t,
      ...n.trim().split(/\s+/)
    ])
  ].join(" ") : n && (n = n.trim().split(/\s+/).join(" ")), !r && !n && e && (r = e), {
    id: t,
    "aria-label": r,
    "aria-labelledby": n
  };
}
let d4 = 0;
const N = /* @__PURE__ */ new Map();
function c4(u) {
  let [e, t] = z();
  return pu(() => {
    if (!u) return;
    let r = N.get(u);
    if (r)
      t(r.element.id);
    else {
      let n = `react-aria-description-${d4++}`;
      t(n);
      let a = document.createElement("div");
      a.id = n, a.style.display = "none", a.textContent = u, document.body.appendChild(a), r = {
        refCount: 0,
        element: a
      }, N.set(u, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), N.delete(u));
    };
  }, [
    u
  ]), {
    "aria-describedby": u ? e : void 0
  };
}
const Cu = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], s4 = Cu.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
Cu.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
function p4(u) {
  return u.matches(s4);
}
function D4(u, e) {
  return !u || !e ? !1 : e.some((t) => t.contains(u));
}
class Y {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(e) {
    return this.fastMap.get(e);
  }
  addTreeNode(e, t, r) {
    let n = this.fastMap.get(t ?? null);
    if (!n) return;
    let a = new uu({
      scopeRef: e
    });
    n.addChild(a), a.parent = n, this.fastMap.set(e, a), r && (a.nodeToRestore = r);
  }
  addNode(e) {
    this.fastMap.set(e.scopeRef, e);
  }
  removeTreeNode(e) {
    if (e === null) return;
    let t = this.fastMap.get(e);
    if (!t) return;
    let r = t.parent;
    for (let a of this.traverse()) a !== t && t.nodeToRestore && a.nodeToRestore && t.scopeRef && t.scopeRef.current && D4(a.nodeToRestore, t.scopeRef.current) && (a.nodeToRestore = t.nodeToRestore);
    let n = t.children;
    r && (r.removeChild(t), n.size > 0 && n.forEach((a) => r && r.addChild(a))), this.fastMap.delete(t.scopeRef);
  }
  // Pre Order Depth First
  *traverse(e = this.root) {
    if (e.scopeRef != null && (yield e), e.children.size > 0) for (let t of e.children) yield* this.traverse(t);
  }
  clone() {
    var e;
    let t = new Y();
    var r;
    for (let n of this.traverse()) t.addTreeNode(n.scopeRef, (r = (e = n.parent) === null || e === void 0 ? void 0 : e.scopeRef) !== null && r !== void 0 ? r : null, n.nodeToRestore);
    return t;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new uu({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class uu {
  addChild(e) {
    this.children.add(e), e.parent = this;
  }
  removeChild(e) {
    this.children.delete(e), e.parent = void 0;
  }
  constructor(e) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = e.scopeRef;
  }
}
new Y();
const B4 = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), C4 = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function E4(u) {
  if (Intl.Locale) {
    let t = new Intl.Locale(u).maximize(), r = typeof t.getTextInfo == "function" ? t.getTextInfo() : t.textInfo;
    if (r) return r.direction === "rtl";
    if (t.script) return B4.has(t.script);
  }
  let e = u.split("-")[0];
  return C4.has(e);
}
const b4 = Symbol.for("react-aria.i18n.locale");
function Eu() {
  let u = typeof window < "u" && window[b4] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      u
    ]);
  } catch {
    u = "en-US";
  }
  return {
    locale: u,
    direction: E4(u) ? "rtl" : "ltr"
  };
}
let H = Eu(), T = /* @__PURE__ */ new Set();
function eu() {
  H = Eu();
  for (let u of T) u(H);
}
function x4() {
  let u = Oe(), [e, t] = z(H);
  return _(() => (T.size === 0 && window.addEventListener("languagechange", eu), T.add(t), () => {
    T.delete(t), T.size === 0 && window.removeEventListener("languagechange", eu);
  }), []), u ? {
    locale: "en-US",
    direction: "ltr"
  } : e;
}
const m4 = /* @__PURE__ */ k.createContext(null);
function $4() {
  let u = x4();
  return a4(m4) || u;
}
const g4 = Symbol.for("react-aria.i18n.locale"), f4 = Symbol.for("react-aria.i18n.strings");
let g;
class R {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(e, t) {
    let n = this.getStringsForLocale(t)[e];
    if (!n) throw new Error(`Could not find intl message ${e} in ${t} locale`);
    return n;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(e) {
    let t = this.strings[e];
    return t || (t = k4(e, this.strings, this.defaultLocale), this.strings[e] = t), t;
  }
  static getGlobalDictionaryForPackage(e) {
    if (typeof window > "u") return null;
    let t = window[g4];
    if (g === void 0) {
      let n = window[f4];
      if (!n) return null;
      g = {};
      for (let a in n) g[a] = new R({
        [t]: n[a]
      }, t);
    }
    let r = g == null ? void 0 : g[e];
    if (!r) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(e, t = "en-US") {
    this.strings = Object.fromEntries(Object.entries(e).filter(([, r]) => r)), this.defaultLocale = t;
  }
}
function k4(u, e, t = "en-US") {
  if (e[u]) return e[u];
  let r = A4(u);
  if (e[r]) return e[r];
  for (let n in e)
    if (n.startsWith(r + "-")) return e[n];
  return e[t];
}
function A4(u) {
  return Intl.Locale ? new Intl.Locale(u).language : u.split("-")[0];
}
const tu = /* @__PURE__ */ new Map(), ru = /* @__PURE__ */ new Map();
class h4 {
  /** Formats a localized string for the given key with the provided variables. */
  format(e, t) {
    let r = this.strings.getStringForLocale(e, this.locale);
    return typeof r == "function" ? r(t, this) : r;
  }
  plural(e, t, r = "cardinal") {
    let n = t["=" + e];
    if (n) return typeof n == "function" ? n() : n;
    let a = this.locale + ":" + r, d = tu.get(a);
    d || (d = new Intl.PluralRules(this.locale, {
      type: r
    }), tu.set(a, d));
    let s = d.select(e);
    return n = t[s] || t.other, typeof n == "function" ? n() : n;
  }
  number(e) {
    let t = ru.get(this.locale);
    return t || (t = new Intl.NumberFormat(this.locale), ru.set(this.locale, t)), t.format(e);
  }
  select(e, t) {
    let r = e[t] || e.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(e, t) {
    this.locale = e, this.strings = t;
  }
}
const au = /* @__PURE__ */ new WeakMap();
function y4(u) {
  let e = au.get(u);
  return e || (e = new R(u), au.set(u, e)), e;
}
function v4(u, e) {
  return e && R.getGlobalDictionaryForPackage(e) || y4(u);
}
function bu(u, e) {
  let { locale: t } = $4(), r = v4(u, e);
  return Du(() => new h4(t, r), [
    t,
    r
  ]);
}
const nu = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function F4(u = {}) {
  let { style: e, isFocusable: t } = u, [r, n] = z(!1), { focusWithinProps: a } = Ne({
    isDisabled: !t,
    onFocusWithinChange: (s) => n(s)
  }), d = Du(() => r ? e : e ? {
    ...nu,
    ...e
  } : nu, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...a,
      style: d
    }
  };
}
function T4(u) {
  let { children: e, elementType: t = "div", isFocusable: r, style: n, ...a } = u, { visuallyHiddenProps: d } = F4(u);
  return /* @__PURE__ */ k.createElement(t, q(a, d), e);
}
var E = /* @__PURE__ */ function(u) {
  return u[u.none = 0] = "none", u[u.cancel = 0] = "cancel", u[u.move = 1] = "move", u[u.copy = 2] = "copy", u[u.link = 4] = "link", u[u.all = 7] = "all", u;
}({});
const xu = {
  ...E,
  copyMove: 3,
  copyLink: 6,
  linkMove: 5,
  all: 7,
  uninitialized: 7
}, z4 = X(xu);
z4[7] = "all";
X(E);
const mu = {
  none: "cancel",
  link: "link",
  copy: "copy",
  move: "move"
}, Z = X(mu);
function X(u) {
  let e = {};
  for (let t in u) e[u[t]] = t;
  return e;
}
const S4 = /* @__PURE__ */ new Set([
  "text/plain",
  "text/uri-list",
  "text/html"
]), V = "application/vnd.react-aria.items+json", L = "application/octet-stream", P4 = Symbol();
function K4(u) {
  return u || (u = "virtual"), u === "pointer" && (u = "virtual"), u === "virtual" && typeof window < "u" && "ontouchstart" in window && (u = "touch"), u;
}
function I4() {
  return K4(Ze());
}
function ou(u, e) {
  let t = /* @__PURE__ */ new Map(), r = !1, n = [];
  for (let a of e) {
    let d = Object.keys(a);
    d.length > 1 && (r = !0);
    let s = {};
    for (let B of d) {
      let c = t.get(B);
      c ? r = !0 : (c = [], t.set(B, c));
      let i = a[B];
      s[B] = i, c.push(i);
    }
    n.push(s);
  }
  for (let [a, d] of t) if (S4.has(a)) {
    let s = d.join(`
`);
    u.items.add(s, a);
  } else
    u.items.add(d[0], a);
  if (r) {
    let a = JSON.stringify(n);
    u.items.add(a, V);
  }
}
class I {
  has(e) {
    return this.includesUnknownTypes || e === P4 && this.types.has(L) ? !0 : typeof e == "string" && this.types.has(e);
  }
  constructor(e) {
    this.types = /* @__PURE__ */ new Set();
    let t = !1;
    for (let r of e.items) r.type !== V && (r.kind === "file" && (t = !0), r.type ? this.types.add(r.type) : this.types.add(L));
    this.includesUnknownTypes = !t && e.types.includes("Files");
  }
}
function $u(u) {
  let e = [];
  if (!u) return e;
  let t = !1;
  if (u.types.includes(V)) try {
    let r = u.getData(V), n = JSON.parse(r);
    for (let a of n) e.push({
      kind: "text",
      types: new Set(Object.keys(a)),
      getText: (d) => Promise.resolve(a[d])
    });
    t = !0;
  } catch {
  }
  if (!t) {
    let r = /* @__PURE__ */ new Map();
    for (let n of u.items)
      if (n.kind === "string")
        r.set(n.type || L, u.getData(n.type));
      else if (n.kind === "file")
        if (typeof n.webkitGetAsEntry == "function") {
          let a = n.webkitGetAsEntry();
          if (!a) continue;
          a.isFile ? e.push(G(n.getAsFile())) : a.isDirectory && e.push(gu(a));
        } else
          e.push(G(n.getAsFile()));
    r.size > 0 && e.push({
      kind: "text",
      types: new Set(r.keys()),
      getText: (n) => Promise.resolve(r.get(n))
    });
  }
  return e;
}
function j4(u) {
  return typeof u.text == "function" ? u.text() : new Promise((e, t) => {
    let r = new FileReader();
    r.onload = () => {
      e(r.result);
    }, r.onerror = t, r.readAsText(u);
  });
}
function G(u) {
  if (!u) throw new Error("No file provided");
  return {
    kind: "file",
    type: u.type || L,
    name: u.name,
    getText: () => j4(u),
    getFile: () => Promise.resolve(u)
  };
}
function gu(u) {
  return {
    kind: "directory",
    name: u.name,
    getEntries: () => w4(u)
  };
}
async function* w4(u) {
  let e = u.createReader(), t;
  do {
    t = await new Promise((r, n) => {
      e.readEntries(r, n);
    });
    for (let r of t)
      if (r.isFile) {
        let n = await V4(r);
        yield G(n);
      } else r.isDirectory && (yield gu(r));
  } while (t.length > 0);
}
function V4(u) {
  return new Promise((e, t) => u.file(e, t));
}
let fu = {
  draggingKeys: /* @__PURE__ */ new Set()
};
function L4(u) {
  fu = u;
}
let iu = E.none, lu = /* @__PURE__ */ new Map(), du = null, cu = /* @__PURE__ */ new Set();
function R4(u) {
  return lu.set(u.element, u), () => {
    lu.delete(u.element);
  };
}
function O4() {
  let [u, e] = z(du);
  return _(() => {
    let t = () => e(du);
    return cu.add(t), () => {
      cu.delete(t);
    };
  }, []), u;
}
var ku = {};
ku = {
  dragDescriptionKeyboard: "اضغط Enter لبدء السحب.",
  dragDescriptionKeyboardAlt: "اضغط على Alt + Enter لبدء السحب.",
  dragDescriptionLongPress: "اضغط باستمرار لبدء السحب.",
  dragDescriptionTouch: "اضغط مرتين لبدء السحب.",
  dragDescriptionVirtual: "انقر لبدء السحب.",
  dragItem: (u) => `اسحب ${u.itemText}`,
  dragSelectedItems: (u, e) => `اسحب ${e.plural(u.count, {
    one: () => `${e.number(u.count)} عنصر محدد`,
    other: () => `${e.number(u.count)} عناصر محددة`
  })}`,
  dragSelectedKeyboard: (u, e) => `اضغط على Enter للسحب ${e.plural(u.count, {
    one: "عدد العناصر المختارة",
    other: "عدد العناصر المختارة"
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `اضغط على مفتاحي Alt + Enter للسحب ${e.plural(u.count, {
    one: "عدد العناصر المختارة",
    other: "عدد العناصر المختارة"
  })}.`,
  dragSelectedLongPress: (u, e) => `اضغط باستمرار للسحب ${e.plural(u.count, {
    one: "عدد العناصر المختارة",
    other: "عدد العناصر المختارة"
  })}.`,
  dragStartedKeyboard: "بدأ السحب. اضغط Tab للانتقال إلى موضع الإفلات، ثم اضغط Enter للإفلات، أو اضغط Escape للإلغاء.",
  dragStartedTouch: "بدأ السحب. انتقل إلى موضع الإفلات، ثم اضغط مرتين للإفلات.",
  dragStartedVirtual: "بدأ السحب. انتقل إلى مكان الإفلات، ثم انقر أو اضغط Enter للإفلات.",
  dropCanceled: "تم إلغاء الإفلات.",
  dropComplete: "اكتمل الإفلات.",
  dropDescriptionKeyboard: "اضغط Enter للإفلات. اضغط Escape لإلغاء السحب.",
  dropDescriptionTouch: "اضغط مرتين للإفلات.",
  dropDescriptionVirtual: "انقر للإفلات.",
  dropIndicator: "مؤشر الإفلات",
  dropOnItem: (u) => `إفلات ${u.itemText}`,
  dropOnRoot: "الإفلات",
  endDragKeyboard: "السحب. اضغط Enter لإلغاء السحب.",
  endDragTouch: "السحب. اضغط مرتين لإلغاء السحب.",
  endDragVirtual: "السحب. انقر لإلغاء السحب.",
  insertAfter: (u) => `أدخل بعد ${u.itemText}`,
  insertBefore: (u) => `أدخل قبل ${u.itemText}`,
  insertBetween: (u) => `أدخل بين ${u.beforeItemText} و ${u.afterItemText}`
};
var Au = {};
Au = {
  dragDescriptionKeyboard: "Натиснете „Enter“, за да започнете да плъзгате.",
  dragDescriptionKeyboardAlt: "Натиснете Alt + Enter, за да започнете да плъзгате.",
  dragDescriptionLongPress: "Натиснете продължително, за да започнете да плъзгате.",
  dragDescriptionTouch: "Натиснете двукратно, за да започнете да плъзгате.",
  dragDescriptionVirtual: "Щракнете, за да започнете да плъзгате.",
  dragItem: (u) => `Плъзни ${u.itemText}`,
  dragSelectedItems: (u, e) => `Плъзни ${e.plural(u.count, {
    one: () => `${e.number(u.count)} избран елемент`,
    other: () => `${e.number(u.count)} избрани елемента`
  })}`,
  dragSelectedKeyboard: (u, e) => `Натиснете Enter, за да плъзнете ${e.plural(u.count, {
    one: () => `${e.number(u.count)} избран елемент`,
    other: () => `${e.number(u.count)} избрани елементи`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Натиснете Alt и Enter, за да плъзнете ${e.plural(u.count, {
    one: () => `${e.number(u.count)} избран елемент`,
    other: () => `${e.number(u.count)} избрани елементи`
  })}.`,
  dragSelectedLongPress: (u, e) => `Натиснете продължително, за да плъзнете ${e.plural(u.count, {
    one: () => `${e.number(u.count)} избран елемент`,
    other: () => `${e.number(u.count)} избрани елементи`
  })}.`,
  dragStartedKeyboard: "Започна плъзгане. Натиснете „Tab“, за да се придвижите до целта, след което натиснете „Enter“ за пускане или натиснете „Escape“ за отмяна.",
  dragStartedTouch: "Започна плъзгане. Придвижете се до целта, след което натиснете двукратно, за да пуснете.",
  dragStartedVirtual: "Започна плъзгане. Придвижете се до целта, след което щракнете или натиснете „Enter“ за пускане.",
  dropCanceled: "Пускането е отменено.",
  dropComplete: "Пускането е завършено.",
  dropDescriptionKeyboard: "Натиснете „Enter“ за пускане. Натиснете „Escape“ за отмяна на плъзгането.",
  dropDescriptionTouch: "Натиснете двукратно за пускане.",
  dropDescriptionVirtual: "Щракнете за пускане.",
  dropIndicator: "индикатор за пускане",
  dropOnItem: (u) => `Пусни върху ${u.itemText}`,
  dropOnRoot: "Пусни върху",
  endDragKeyboard: "Плъзгане. Натиснете „Enter“ за отмяна на плъзгането.",
  endDragTouch: "Плъзгане. Натиснете двукратно за отмяна на плъзгането.",
  endDragVirtual: "Плъзгане. Щракнете за отмяна.",
  insertAfter: (u) => `Вмъкни след ${u.itemText}`,
  insertBefore: (u) => `Вмъкни преди ${u.itemText}`,
  insertBetween: (u) => `Вмъкни между ${u.beforeItemText} и ${u.afterItemText}`
};
var hu = {};
hu = {
  dragDescriptionKeyboard: "Stisknutím klávesy Enter začnete s přetahováním.",
  dragDescriptionKeyboardAlt: "Stisknutím Alt + Enter zahájíte přetahování.",
  dragDescriptionLongPress: "Dlouhým stisknutím zahájíte přetahování.",
  dragDescriptionTouch: "Poklepáním začnete s přetahováním.",
  dragDescriptionVirtual: "Kliknutím začnete s přetahováním.",
  dragItem: (u) => `Přetáhnout ${u.itemText}`,
  dragSelectedItems: (u, e) => `Přetáhnout ${e.plural(u.count, {
    one: () => `${e.number(u.count)} vybranou položku`,
    few: () => `${e.number(u.count)} vybrané položky`,
    other: () => `${e.number(u.count)} vybraných položek`
  })}`,
  dragSelectedKeyboard: (u, e) => `Stisknutím klávesy Enter přetáhněte ${e.plural(u.count, {
    one: () => `${e.number(u.count)} vybranou položku`,
    other: () => `${e.number(u.count)} vybrané položky`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Stisknutím Alt + Enter přetáhněte ${e.plural(u.count, {
    one: () => `${e.number(u.count)} vybranou položku`,
    other: () => `${e.number(u.count)} vybrané položky`
  })}.`,
  dragSelectedLongPress: (u, e) => `Dlouhým stisknutím přetáhnete ${e.plural(u.count, {
    one: () => `${e.number(u.count)} vybranou položku`,
    other: () => `${e.number(u.count)} vybrané položky`
  })}.`,
  dragStartedKeyboard: "Začněte s přetahováním. Po stisknutí klávesy Tab najděte požadovaný cíl a stisknutím klávesy Enter přetažení dokončete nebo stisknutím klávesy Esc akci zrušte.",
  dragStartedTouch: "Začněte s přetahováním. Najděte požadovaný cíl a poklepáním přetažení dokončete.",
  dragStartedVirtual: "Začněte s přetahováním. Najděte požadovaný cíl a kliknutím nebo stisknutím klávesy Enter přetažení dokončete.",
  dropCanceled: "Přetažení bylo zrušeno.",
  dropComplete: "Přetažení bylo dokončeno.",
  dropDescriptionKeyboard: "Stisknutím klávesy Enter přetažení dokončete nebo stisknutím klávesy Esc akci zrušte.",
  dropDescriptionTouch: "Poklepáním přetažení dokončete.",
  dropDescriptionVirtual: "Kliknutím objekt přetáhněte.",
  dropIndicator: "indikátor přetažení",
  dropOnItem: (u) => `Přetáhnout na ${u.itemText}`,
  dropOnRoot: "Přetáhnout na",
  endDragKeyboard: "Probíhá přetahování. Stisknutím klávesy Enter přetažení zrušíte.",
  endDragTouch: "Probíhá přetahování. Poklepáním přetažení zrušíte.",
  endDragVirtual: "Probíhá přetahování. Kliknutím přetažení zrušíte.",
  insertAfter: (u) => `Vložit za ${u.itemText}`,
  insertBefore: (u) => `Vložit před ${u.itemText}`,
  insertBetween: (u) => `Vložit mezi ${u.beforeItemText} a ${u.afterItemText}`
};
var yu = {};
yu = {
  dragDescriptionKeyboard: "Tryk på Enter for at starte med at trække.",
  dragDescriptionKeyboardAlt: "Tryk på Alt + Enter for at starte med at trække.",
  dragDescriptionLongPress: "Tryk længe for at starte med at trække.",
  dragDescriptionTouch: "Dobbelttryk for at starte med at trække.",
  dragDescriptionVirtual: "Klik for at starte med at trække.",
  dragItem: (u) => `Træk ${u.itemText}`,
  dragSelectedItems: (u, e) => `Træk ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valgt element`,
    other: () => `${e.number(u.count)} valgte elementer`
  })}`,
  dragSelectedKeyboard: (u, e) => `Tryk på Enter for at trække ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valgte element`,
    other: () => `${e.number(u.count)} valgte elementer`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Tryk på Alt + Enter for at trække ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valgte element`,
    other: () => `${e.number(u.count)} valgte elementer`
  })}.`,
  dragSelectedLongPress: (u, e) => `Tryk længe for at trække ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valgte element`,
    other: () => `${e.number(u.count)} valgte elementer`
  })}.`,
  dragStartedKeyboard: "Startet med at trække. Tryk på Tab for at gå til et slip-mål, tryk derefter på Enter for at slippe, eller tryk på Escape for at annullere.",
  dragStartedTouch: "Startet med at trække. Gå til et slip-mål, og dobbelttryk derefter for at slippe.",
  dragStartedVirtual: "Startet med at trække. Gå til et slip-mål, og klik eller tryk derefter på enter for at slippe.",
  dropCanceled: "Slip annulleret.",
  dropComplete: "Slip fuldført.",
  dropDescriptionKeyboard: "Tryk på Enter for at slippe. Tryk på Escape for at annullere trækning.",
  dropDescriptionTouch: "Dobbelttryk for at slippe.",
  dropDescriptionVirtual: "Klik for at slippe.",
  dropIndicator: "slip-indikator",
  dropOnItem: (u) => `Slip på ${u.itemText}`,
  dropOnRoot: "Slip på",
  endDragKeyboard: "Trækning. Tryk på enter for at annullere træk.",
  endDragTouch: "Trækning. Dobbelttryk for at annullere træk.",
  endDragVirtual: "Trækning. Klik for at annullere trækning.",
  insertAfter: (u) => `Indsæt efter ${u.itemText}`,
  insertBefore: (u) => `Indsæt før ${u.itemText}`,
  insertBetween: (u) => `Indsæt mellem ${u.beforeItemText} og ${u.afterItemText}`
};
var vu = {};
vu = {
  dragDescriptionKeyboard: "Drücken Sie die Eingabetaste, um den Ziehvorgang zu starten.",
  dragDescriptionKeyboardAlt: "Alt + Eingabe drücken, um den Ziehvorgang zu starten.",
  dragDescriptionLongPress: "Lang drücken, um mit dem Ziehen zu beginnen.",
  dragDescriptionTouch: "Tippen Sie doppelt, um den Ziehvorgang zu starten.",
  dragDescriptionVirtual: "Zum Starten des Ziehvorgangs klicken.",
  dragItem: (u) => `${u.itemText} ziehen`,
  dragSelectedItems: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)} ausgewähltes Objekt`,
    other: () => `${e.number(u.count)} ausgewählte Objekte`
  })} ziehen`,
  dragSelectedKeyboard: (u, e) => `Eingabetaste drücken, um ${e.plural(u.count, {
    one: () => `${e.number(u.count)} ausgewähltes Element`,
    other: () => `${e.number(u.count)} ausgewählte Elemente`
  })} zu ziehen.`,
  dragSelectedKeyboardAlt: (u, e) => `Alt + Eingabetaste drücken, um ${e.plural(u.count, {
    one: () => `${e.number(u.count)} ausgewähltes Element`,
    other: () => `${e.number(u.count)} ausgewählte Elemente`
  })} zu ziehen.`,
  dragSelectedLongPress: (u, e) => `Lang drücken, um ${e.plural(u.count, {
    one: () => `${e.number(u.count)} ausgewähltes Element`,
    other: () => `${e.number(u.count)} ausgewählte Elemente`
  })} zu ziehen.`,
  dragStartedKeyboard: "Ziehvorgang gestartet. Drücken Sie die Tabulatortaste, um zu einem Ablegeziel zu navigieren und drücken Sie dann die Eingabetaste, um das Objekt abzulegen, oder Escape, um den Vorgang abzubrechen.",
  dragStartedTouch: "Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und tippen Sie doppelt, um das Objekt abzulegen.",
  dragStartedVirtual: "Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und klicken Sie oder drücken Sie die Eingabetaste, um das Objekt abzulegen.",
  dropCanceled: "Ablegen abgebrochen.",
  dropComplete: "Ablegen abgeschlossen.",
  dropDescriptionKeyboard: "Drücken Sie die Eingabetaste, um das Objekt abzulegen. Drücken Sie Escape, um den Vorgang abzubrechen.",
  dropDescriptionTouch: "Tippen Sie doppelt, um das Objekt abzulegen.",
  dropDescriptionVirtual: "Zum Ablegen klicken.",
  dropIndicator: "Ablegeanzeiger",
  dropOnItem: (u) => `Auf ${u.itemText} ablegen`,
  dropOnRoot: "Ablegen auf",
  endDragKeyboard: "Ziehvorgang läuft. Drücken Sie die Eingabetaste, um den Vorgang abzubrechen.",
  endDragTouch: "Ziehvorgang läuft. Tippen Sie doppelt, um den Vorgang abzubrechen.",
  endDragVirtual: "Ziehvorgang läuft. Klicken Sie, um den Vorgang abzubrechen.",
  insertAfter: (u) => `Nach ${u.itemText} einfügen`,
  insertBefore: (u) => `Vor ${u.itemText} einfügen`,
  insertBetween: (u) => `Zwischen ${u.beforeItemText} und ${u.afterItemText} einfügen`
};
var Fu = {};
Fu = {
  dragDescriptionKeyboard: "Πατήστε Enter για έναρξη της μεταφοράς.",
  dragDescriptionKeyboardAlt: "Πατήστε Alt + Enter για έναρξη της μεταφοράς.",
  dragDescriptionLongPress: "Πατήστε παρατεταμένα για να ξεκινήσετε τη μεταφορά.",
  dragDescriptionTouch: "Πατήστε δύο φορές για έναρξη της μεταφοράς.",
  dragDescriptionVirtual: "Κάντε κλικ για να ξεκινήσετε τη μεταφορά.",
  dragItem: (u) => `Μεταφορά ${u.itemText}`,
  dragSelectedItems: (u, e) => `Μεταφορά σε ${e.plural(u.count, {
    one: () => `${e.number(u.count)} επιλεγμένο στοιχείο`,
    other: () => `${e.number(u.count)} επιλεγμένα στοιχεία`
  })}`,
  dragSelectedKeyboard: (u, e) => `Πατήστε Enter για να σύρετε ${e.plural(u.count, {
    one: () => `${e.number(u.count)} επιλεγμένο στοιχείο`,
    other: () => `${e.number(u.count)} επιλεγμένα στοιχεία`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Πατήστε Alt + Enter για να σύρετε ${e.plural(u.count, {
    one: () => `${e.number(u.count)} επιλεγμένο στοιχείο`,
    other: () => `${e.number(u.count)} επιλεγμένα στοιχεία`
  })}.`,
  dragSelectedLongPress: (u, e) => `Πατήστε παρατεταμένα για να σύρετε ${e.plural(u.count, {
    one: () => `${e.number(u.count)} επιλεγμένο στοιχείο`,
    other: () => `${e.number(u.count)} επιλεγμένα στοιχεία`
  })}.`,
  dragStartedKeyboard: "Η μεταφορά ξεκίνησε. Πατήστε το πλήκτρο Tab για να μεταβείτε σε έναν προορισμό απόθεσης και, στη συνέχεια, πατήστε Enter για απόθεση ή πατήστε Escape για ακύρωση.",
  dragStartedTouch: "Η μεταφορά ξεκίνησε. Μεταβείτε σε έναν προορισμό απόθεσης και, στη συνέχεια, πατήστε δύο φορές για απόθεση.",
  dragStartedVirtual: "Η μεταφορά ξεκίνησε. Μεταβείτε σε έναν προορισμό απόθεσης και, στη συνέχεια, κάντε κλικ ή πατήστε Enter για απόθεση.",
  dropCanceled: "Η απόθεση ακυρώθηκε.",
  dropComplete: "Η απόθεση ολοκληρώθηκε.",
  dropDescriptionKeyboard: "Πατήστε Enter για απόθεση. Πατήστε Escape για ακύρωση της μεταφοράς.",
  dropDescriptionTouch: "Πατήστε δύο φορές για απόθεση.",
  dropDescriptionVirtual: "Κάντε κλικ για απόθεση.",
  dropIndicator: "δείκτης απόθεσης",
  dropOnItem: (u) => `Απόθεση σε ${u.itemText}`,
  dropOnRoot: "Απόθεση σε",
  endDragKeyboard: "Μεταφορά σε εξέλιξη. Πατήστε Enter για ακύρωση της μεταφοράς.",
  endDragTouch: "Μεταφορά σε εξέλιξη. Πατήστε δύο φορές για ακύρωση της μεταφοράς.",
  endDragVirtual: "Μεταφορά σε εξέλιξη. Κάντε κλικ για ακύρωση της μεταφοράς.",
  insertAfter: (u) => `Εισαγωγή μετά από ${u.itemText}`,
  insertBefore: (u) => `Εισαγωγή πριν από ${u.itemText}`,
  insertBetween: (u) => `Εισαγωγή μεταξύ ${u.beforeItemText} και ${u.afterItemText}`
};
var Tu = {};
Tu = {
  dragItem: (u) => `Drag ${u.itemText}`,
  dragSelectedItems: (u, e) => `Drag ${e.plural(u.count, {
    one: () => `${e.number(u.count)} selected item`,
    other: () => `${e.number(u.count)} selected items`
  })}`,
  dragDescriptionKeyboard: "Press Enter to start dragging.",
  dragDescriptionKeyboardAlt: "Press Alt + Enter to start dragging.",
  dragDescriptionTouch: "Double tap to start dragging.",
  dragDescriptionVirtual: "Click to start dragging.",
  dragDescriptionLongPress: "Long press to start dragging.",
  dragSelectedKeyboard: (u, e) => `Press Enter to drag ${e.plural(u.count, {
    one: () => `${e.number(u.count)} selected item`,
    other: () => `${e.number(u.count)} selected items`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Press Alt + Enter to drag ${e.plural(u.count, {
    one: () => `${e.number(u.count)} selected item`,
    other: () => `${e.number(u.count)} selected items`
  })}.`,
  dragSelectedLongPress: (u, e) => `Long press to drag ${e.plural(u.count, {
    one: () => `${e.number(u.count)} selected item`,
    other: () => `${e.number(u.count)} selected items`
  })}.`,
  dragStartedKeyboard: "Started dragging. Press Tab to navigate to a drop target, then press Enter to drop, or press Escape to cancel.",
  dragStartedTouch: "Started dragging. Navigate to a drop target, then double tap to drop.",
  dragStartedVirtual: "Started dragging. Navigate to a drop target, then click or press Enter to drop.",
  endDragKeyboard: "Dragging. Press Enter to cancel drag.",
  endDragTouch: "Dragging. Double tap to cancel drag.",
  endDragVirtual: "Dragging. Click to cancel drag.",
  dropDescriptionKeyboard: "Press Enter to drop. Press Escape to cancel drag.",
  dropDescriptionTouch: "Double tap to drop.",
  dropDescriptionVirtual: "Click to drop.",
  dropCanceled: "Drop canceled.",
  dropComplete: "Drop complete.",
  dropIndicator: "drop indicator",
  dropOnRoot: "Drop on",
  dropOnItem: (u) => `Drop on ${u.itemText}`,
  insertBefore: (u) => `Insert before ${u.itemText}`,
  insertBetween: (u) => `Insert between ${u.beforeItemText} and ${u.afterItemText}`,
  insertAfter: (u) => `Insert after ${u.itemText}`
};
var zu = {};
zu = {
  dragDescriptionKeyboard: "Pulse Intro para empezar a arrastrar.",
  dragDescriptionKeyboardAlt: "Pulse Intro para empezar a arrastrar.",
  dragDescriptionLongPress: "Mantenga pulsado para comenzar a arrastrar.",
  dragDescriptionTouch: "Pulse dos veces para iniciar el arrastre.",
  dragDescriptionVirtual: "Haga clic para iniciar el arrastre.",
  dragItem: (u) => `Arrastrar ${u.itemText}`,
  dragSelectedItems: (u, e) => `Arrastrar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} elemento seleccionado`,
    other: () => `${e.number(u.count)} elementos seleccionados`
  })}`,
  dragSelectedKeyboard: (u, e) => `Pulse Intro para arrastrar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} elemento seleccionado`,
    other: () => `${e.number(u.count)} elementos seleccionados`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Pulse Alt + Intro para arrastrar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} elemento seleccionado`,
    other: () => `${e.number(u.count)} elementos seleccionados`
  })}.`,
  dragSelectedLongPress: (u, e) => `Mantenga pulsado para arrastrar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} elemento seleccionado`,
    other: () => `${e.number(u.count)} elementos seleccionados`
  })}.`,
  dragStartedKeyboard: "Se ha empezado a arrastrar. Pulse el tabulador para ir al público destinatario donde se vaya a colocar y, a continuación, pulse Intro para soltar, o pulse Escape para cancelar.",
  dragStartedTouch: "Se ha empezado a arrastrar. Vaya al público destinatario donde se vaya a colocar y, a continuación, pulse dos veces para soltar.",
  dragStartedVirtual: "Se ha empezado a arrastrar. Vaya al público destinatario donde se vaya a colocar y, a continuación, haga clic o pulse Intro para soltar.",
  dropCanceled: "Se ha cancelado la colocación.",
  dropComplete: "Colocación finalizada.",
  dropDescriptionKeyboard: "Pulse Intro para soltar. Pulse Escape para cancelar el arrastre.",
  dropDescriptionTouch: "Pulse dos veces para soltar.",
  dropDescriptionVirtual: "Haga clic para soltar.",
  dropIndicator: "indicador de colocación",
  dropOnItem: (u) => `Soltar en ${u.itemText}`,
  dropOnRoot: "Soltar en",
  endDragKeyboard: "Arrastrando. Pulse Intro para cancelar el arrastre.",
  endDragTouch: "Arrastrando. Pulse dos veces para cancelar el arrastre.",
  endDragVirtual: "Arrastrando. Haga clic para cancelar el arrastre.",
  insertAfter: (u) => `Insertar después de ${u.itemText}`,
  insertBefore: (u) => `Insertar antes de ${u.itemText}`,
  insertBetween: (u) => `Insertar entre ${u.beforeItemText} y ${u.afterItemText}`
};
var Su = {};
Su = {
  dragDescriptionKeyboard: "Lohistamise alustamiseks vajutage klahvi Enter.",
  dragDescriptionKeyboardAlt: "Lohistamise alustamiseks vajutage klahvikombinatsiooni Alt + Enter.",
  dragDescriptionLongPress: "Vajutage pikalt lohistamise alustamiseks.",
  dragDescriptionTouch: "Topeltpuudutage lohistamise alustamiseks.",
  dragDescriptionVirtual: "Klõpsake lohistamise alustamiseks.",
  dragItem: (u) => `Lohista ${u.itemText}`,
  dragSelectedItems: (u, e) => `Lohista ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valitud üksust`,
    other: () => `${e.number(u.count)} valitud üksust`
  })}`,
  dragSelectedKeyboard: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)} valitud üksuse`,
    other: () => `${e.number(u.count)} valitud üksuse`
  })} lohistamiseks vajutage sisestusklahvi Enter.`,
  dragSelectedKeyboardAlt: (u, e) => `Lohistamiseks vajutage klahvikombinatsiooni Alt + Enter ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valitud üksuse`,
    other: () => `${e.number(u.count)} valitud üksuse`
  })} jaoks.`,
  dragSelectedLongPress: (u, e) => `Pikk vajutus ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valitud üksuse`,
    other: () => `${e.number(u.count)} valitud üksuse`
  })} lohistamiseks.`,
  dragStartedKeyboard: "Alustati lohistamist. Kukutamise sihtmärgi juurde navigeerimiseks vajutage klahvi Tab, seejärel vajutage kukutamiseks klahvi Enter või loobumiseks klahvi Escape.",
  dragStartedTouch: "Alustati lohistamist. Navigeerige kukutamise sihtmärgi juurde ja topeltpuudutage kukutamiseks.",
  dragStartedVirtual: "Alustati lohistamist. Navigeerige kukutamise sihtmärgi juurde ja kukutamiseks klõpsake või vajutage klahvi Enter.",
  dropCanceled: "Lohistamisest loobuti.",
  dropComplete: "Lohistamine on tehtud.",
  dropDescriptionKeyboard: "Kukutamiseks vajutage klahvi Enter. Lohistamisest loobumiseks vajutage klahvi Escape.",
  dropDescriptionTouch: "Kukutamiseks topeltpuudutage.",
  dropDescriptionVirtual: "Kukutamiseks klõpsake.",
  dropIndicator: "lohistamise indikaator",
  dropOnItem: (u) => `Kukuta asukohta ${u.itemText}`,
  dropOnRoot: "Kukuta asukohta",
  endDragKeyboard: "Lohistamine. Lohistamisest loobumiseks vajutage klahvi Enter.",
  endDragTouch: "Lohistamine. Lohistamisest loobumiseks topeltpuudutage.",
  endDragVirtual: "Lohistamine. Lohistamisest loobumiseks klõpsake.",
  insertAfter: (u) => `Sisesta ${u.itemText} järele`,
  insertBefore: (u) => `Sisesta ${u.itemText} ette`,
  insertBetween: (u) => `Sisesta ${u.beforeItemText} ja ${u.afterItemText} vahele`
};
var Pu = {};
Pu = {
  dragDescriptionKeyboard: "Aloita vetäminen painamalla Enter-näppäintä.",
  dragDescriptionKeyboardAlt: "Aloita vetäminen painamalla Alt + Enter -näppäinyhdistelmää.",
  dragDescriptionLongPress: "Aloita vetäminen pitämällä painettuna.",
  dragDescriptionTouch: "Aloita vetäminen kaksoisnapauttamalla.",
  dragDescriptionVirtual: "Aloita vetäminen napsauttamalla.",
  dragItem: (u) => `Vedä kohdetta ${u.itemText}`,
  dragSelectedItems: (u, e) => `Vedä ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valittua kohdetta`,
    other: () => `${e.number(u.count)} valittua kohdetta`
  })}`,
  dragSelectedKeyboard: (u, e) => `Vedä painamalla Enter ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valittu kohde`,
    other: () => `${e.number(u.count)} valittua kohdetta`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Vedä painamalla Alt + Enter ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valittu kohde`,
    other: () => `${e.number(u.count)} valittua kohdetta`
  })}.`,
  dragSelectedLongPress: (u, e) => `Vedä pitämällä painettuna ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valittu kohde`,
    other: () => `${e.number(u.count)} valittua kohdetta`
  })}.`,
  dragStartedKeyboard: "Vetäminen aloitettu. Siirry pudotuskohteeseen painamalla sarkainnäppäintä ja sitten pudota painamalla Enter-näppäintä tai peruuta painamalla Escape-näppäintä.",
  dragStartedTouch: "Vetäminen aloitettu. Siirry pudotuskohteeseen ja pudota kaksoisnapauttamalla.",
  dragStartedVirtual: "Vetäminen aloitettu. Siirry pudotuskohteeseen ja pudota napsauttamalla tai painamalla Enter-näppäintä.",
  dropCanceled: "Pudotus peruutettu.",
  dropComplete: "Pudotus suoritettu.",
  dropDescriptionKeyboard: "Pudota painamalla Enter-näppäintä. Peruuta vetäminen painamalla Escape-näppäintä.",
  dropDescriptionTouch: "Pudota kaksoisnapauttamalla.",
  dropDescriptionVirtual: "Pudota napsauttamalla.",
  dropIndicator: "pudotuksen ilmaisin",
  dropOnItem: (u) => `Pudota kohteeseen ${u.itemText}`,
  dropOnRoot: "Pudota kohteeseen",
  endDragKeyboard: "Vedetään. Peruuta vetäminen painamalla Enter-näppäintä.",
  endDragTouch: "Vedetään. Peruuta vetäminen kaksoisnapauttamalla.",
  endDragVirtual: "Vedetään. Peruuta vetäminen napsauttamalla.",
  insertAfter: (u) => `Lisää kohteen ${u.itemText} jälkeen`,
  insertBefore: (u) => `Lisää ennen kohdetta ${u.itemText}`,
  insertBetween: (u) => `Lisää kohteiden ${u.beforeItemText} ja ${u.afterItemText} väliin`
};
var Ku = {};
Ku = {
  dragDescriptionKeyboard: "Appuyez sur Entrée pour commencer le déplacement.",
  dragDescriptionKeyboardAlt: "Appuyez sur Alt + Entrée pour commencer à faire glisser.",
  dragDescriptionLongPress: "Appuyez de manière prolongée pour commencer à faire glisser.",
  dragDescriptionTouch: "Touchez deux fois pour commencer le déplacement.",
  dragDescriptionVirtual: "Cliquez pour commencer le déplacement.",
  dragItem: (u) => `Déplacer ${u.itemText}`,
  dragSelectedItems: (u, e) => `Déplacer ${e.plural(u.count, {
    one: () => `${e.number(u.count)} élément sélectionné`,
    other: () => `${e.number(u.count)} éléments sélectionnés`
  })}`,
  dragSelectedKeyboard: (u, e) => `Appuyez sur Entrée pour faire glisser ${e.plural(u.count, {
    one: () => `${e.number(u.count)} élément sélectionné`,
    other: () => `${e.number(u.count)} éléments sélectionnés`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Appuyez sur Alt + Entrée pour faire glisser ${e.plural(u.count, {
    one: () => `${e.number(u.count)} élément sélectionné`,
    other: () => `${e.number(u.count)} éléments sélectionnés`
  })}.`,
  dragSelectedLongPress: (u, e) => `Appuyez de manière prolongée pour faire glisser ${e.plural(u.count, {
    one: () => `${e.number(u.count)} élément sélectionné`,
    other: () => `${e.number(u.count)} éléments sélectionnés`
  })}.`,
  dragStartedKeyboard: "Déplacement commencé. Appuyez sur Tabulation pour accéder à une cible de dépôt, puis appuyez sur Entrée pour déposer, ou appuyez sur Échap pour annuler.",
  dragStartedTouch: "Déplacement commencé. Accédez à une cible de dépôt, puis touchez deux fois pour déposer.",
  dragStartedVirtual: "Déplacement commencé. Accédez à une cible de dépôt, puis cliquez ou appuyez sur Entrée pour déposer.",
  dropCanceled: "Dépôt annulé.",
  dropComplete: "Dépôt terminé.",
  dropDescriptionKeyboard: "Appuyez sur Entrée pour déposer. Appuyez sur Échap pour annuler le déplacement.",
  dropDescriptionTouch: "Touchez deux fois pour déposer.",
  dropDescriptionVirtual: "Cliquez pour déposer.",
  dropIndicator: "indicateur de dépôt",
  dropOnItem: (u) => `Déposer sur ${u.itemText}`,
  dropOnRoot: "Déposer sur",
  endDragKeyboard: "Déplacement. Appuyez sur Entrée pour annuler le déplacement.",
  endDragTouch: "Déplacement. Touchez deux fois pour annuler le déplacement.",
  endDragVirtual: "Déplacement. Cliquez pour annuler le déplacement.",
  insertAfter: (u) => `Insérer après ${u.itemText}`,
  insertBefore: (u) => `Insérer avant ${u.itemText}`,
  insertBetween: (u) => `Insérer entre ${u.beforeItemText} et ${u.afterItemText}`
};
var Iu = {};
Iu = {
  dragDescriptionKeyboard: "הקש על Enter כדי להתחיל לגרור.",
  dragDescriptionKeyboardAlt: "הקש Alt + Enter כדי להתחיל לגרור.",
  dragDescriptionLongPress: "לחץ לחיצה ארוכה כדי להתחיל לגרור.",
  dragDescriptionTouch: "הקש פעמיים כדי להתחיל בגרירה.",
  dragDescriptionVirtual: "לחץ כדי להתחיל לגרור.",
  dragItem: (u) => `גרור את ${u.itemText}`,
  dragSelectedItems: (u, e) => `גרור ${e.plural(u.count, {
    one: () => `פריט נבחר ${e.number(u.count)}`,
    other: () => `${e.number(u.count)} פריטים שנבחרו`
  })}`,
  dragSelectedKeyboard: (u, e) => `הקש על Enter כדי לגרור ${e.plural(u.count, {
    one: () => `${e.number(u.count)} פריט שנבחר`,
    other: () => `${e.number(u.count)} פריטים שנבחרו`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `הקש Alt + Enter כדי לגרור ${e.plural(u.count, {
    one: () => `${e.number(u.count)} פריט שנבחר`,
    other: () => `${e.number(u.count)} פריטים שנבחרו`
  })}.`,
  dragSelectedLongPress: (u, e) => `לחץ לחיצה ארוכה כדי לגרור ${e.plural(u.count, {
    one: () => `${e.number(u.count)} פריט שנבחר`,
    other: () => `${e.number(u.count)} פריטים שנבחרו`
  })}.`,
  dragStartedKeyboard: "התחלת לגרור. הקש על Tab כדי לנווט לנקודת הגרירה ולאחר מכן הקש על Enter כדי לשחרר או על Escape כדי לבטל.",
  dragStartedTouch: "התחלת לגרור. נווט לנקודת השחרור ולאחר מכן הקש פעמיים כדי לשחרר.",
  dragStartedVirtual: "התחלת לגרור. נווט לנקודת השחרור ולאחר מכן לחץ או הקש על Enter כדי לשחרר.",
  dropCanceled: "השחרור בוטל.",
  dropComplete: "השחרור הושלם.",
  dropDescriptionKeyboard: "הקש על Enter כדי לשחרר. הקש על Escape כדי לבטל את הגרירה.",
  dropDescriptionTouch: "הקש פעמיים כדי לשחרר.",
  dropDescriptionVirtual: "לחץ כדי לשחרר.",
  dropIndicator: "מחוון שחרור",
  dropOnItem: (u) => `שחרר על ${u.itemText}`,
  dropOnRoot: "שחרר על",
  endDragKeyboard: "גורר. הקש על Enter כדי לבטל את הגרירה.",
  endDragTouch: "גורר. הקש פעמיים כדי לבטל את הגרירה.",
  endDragVirtual: "גורר. לחץ כדי לבטל את הגרירה.",
  insertAfter: (u) => `הוסף אחרי ${u.itemText}`,
  insertBefore: (u) => `הוסף לפני ${u.itemText}`,
  insertBetween: (u) => `הוסף בין ${u.beforeItemText} לבין ${u.afterItemText}`
};
var ju = {};
ju = {
  dragDescriptionKeyboard: "Pritisnite Enter da biste počeli povlačiti.",
  dragDescriptionKeyboardAlt: "Pritisnite Alt + Enter za početak povlačenja.",
  dragDescriptionLongPress: "Dugo pritisnite za početak povlačenja.",
  dragDescriptionTouch: "Dvaput dodirnite da biste počeli povlačiti.",
  dragDescriptionVirtual: "Kliknite da biste počeli povlačiti.",
  dragItem: (u) => `Povucite stavku ${u.itemText}`,
  dragSelectedItems: (u, e) => `Povucite ${e.plural(u.count, {
    one: () => `${e.number(u.count)} odabranu stavku`,
    other: () => `ovoliko odabranih stavki: ${e.number(u.count)}`
  })}`,
  dragSelectedKeyboard: (u, e) => `Pritisnite Enter za povlačenje ${e.plural(u.count, {
    one: () => `${e.number(u.count)} odabrana stavka`,
    other: () => `${e.number(u.count)} odabrane stavke`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Pritisnite Alt + Enter za povlačenje ${e.plural(u.count, {
    one: () => `${e.number(u.count)} odabrana stavka`,
    other: () => `${e.number(u.count)} odabrane stavke`
  })}.`,
  dragSelectedLongPress: (u, e) => `Dugo pritisnite za povlačenje ${e.plural(u.count, {
    one: () => `${e.number(u.count)} odabrana stavka`,
    other: () => `${e.number(u.count)} odabrane stavke`
  })}.`,
  dragStartedKeyboard: "Počeli ste povlačiti. Pritisnite tipku tabulatora da biste došli do cilja ispuštanja, a zatim Enter da biste ispustili stavku ili Escape da biste prekinuli povlačenje.",
  dragStartedTouch: "Počeli ste povlačiti. Dođite do cilja ispuštanja, a zatim dvaput dodirnite da biste ispustili stavku.",
  dragStartedVirtual: "Počeli ste povlačiti. Dođite do cilja ispuštanja, a zatim kliknite ili pritisnite Enter da biste ispustili stavku.",
  dropCanceled: "Povlačenje je prekinuto.",
  dropComplete: "Ispuštanje je dovršeno.",
  dropDescriptionKeyboard: "Pritisnite Enter da biste ispustili stavku. Pritisnite Escape da biste prekinuli povlačenje.",
  dropDescriptionTouch: "Dvaput dodirnite da biste ispustili stavku.",
  dropDescriptionVirtual: "Kliknite da biste ispustili stavku.",
  dropIndicator: "pokazatelj ispuštanja",
  dropOnItem: (u) => `Ispustite na stavku ${u.itemText}`,
  dropOnRoot: "Ispustite na",
  endDragKeyboard: "Povlačenje. Pritisnite Enter da biste prekinuli povlačenje.",
  endDragTouch: "Povlačenje. Dvaput dodirnite da biste prekinuli povlačenje.",
  endDragVirtual: "Povlačenje. Kliknite da biste prekinuli povlačenje.",
  insertAfter: (u) => `Umetnite iza stavke ${u.itemText}`,
  insertBefore: (u) => `Ispustite ispred stavke ${u.itemText}`,
  insertBetween: (u) => `Umetnite između stavki ${u.beforeItemText} i ${u.afterItemText}`
};
var wu = {};
wu = {
  dragDescriptionKeyboard: "Nyomja le az Enter billentyűt a húzás megkezdéséhez.",
  dragDescriptionKeyboardAlt: "Nyomja le az Alt + Enter billentyűket a húzás megkezdéséhez.",
  dragDescriptionLongPress: "Hosszan nyomja meg a húzás elindításához.",
  dragDescriptionTouch: "Koppintson duplán a húzás megkezdéséhez.",
  dragDescriptionVirtual: "Kattintson a húzás megkezdéséhez.",
  dragItem: (u) => `${u.itemText} húzása`,
  dragSelectedItems: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)} kijelölt elem`,
    other: () => `${e.number(u.count)} kijelölt elem`
  })} húzása`,
  dragSelectedKeyboard: (u, e) => `Nyomja meg az Entert ${e.plural(u.count, {
    one: () => `${e.number(u.count)} kijelölt elem`,
    other: () => `${e.number(u.count)} kijelölt elem`
  })} húzásához.`,
  dragSelectedKeyboardAlt: (u, e) => `Nyomja meg az Alt + Enter billentyűket ${e.plural(u.count, {
    one: () => `${e.number(u.count)} kijelölt elem`,
    other: () => `${e.number(u.count)} kijelölt elem`
  })} húzásához.`,
  dragSelectedLongPress: (u, e) => `Tartsa lenyomva hosszan ${e.plural(u.count, {
    one: () => `${e.number(u.count)} kijelölt elem`,
    other: () => `${e.number(u.count)} kijelölt elem`
  })} húzásához.`,
  dragStartedKeyboard: "Húzás megkezdve. Nyomja le a Tab billentyűt az elengedési célhoz navigálásához, majd nyomja le az Enter billentyűt az elengedéshez, vagy nyomja le az Escape billentyűt a megszakításhoz.",
  dragStartedTouch: "Húzás megkezdve. Navigáljon egy elengedési célhoz, majd koppintson duplán az elengedéshez.",
  dragStartedVirtual: "Húzás megkezdve. Navigáljon egy elengedési célhoz, majd kattintson vagy nyomja le az Enter billentyűt az elengedéshez.",
  dropCanceled: "Elengedés megszakítva.",
  dropComplete: "Elengedés teljesítve.",
  dropDescriptionKeyboard: "Nyomja le az Enter billentyűt az elengedéshez. Nyomja le az Escape billentyűt a húzás megszakításához.",
  dropDescriptionTouch: "Koppintson duplán az elengedéshez.",
  dropDescriptionVirtual: "Kattintson az elengedéshez.",
  dropIndicator: "elengedésjelző",
  dropOnItem: (u) => `Elengedés erre: ${u.itemText}`,
  dropOnRoot: "Elengedés erre:",
  endDragKeyboard: "Húzás folyamatban. Nyomja le az Enter billentyűt a húzás megszakításához.",
  endDragTouch: "Húzás folyamatban. Koppintson duplán a húzás megszakításához.",
  endDragVirtual: "Húzás folyamatban. Kattintson a húzás megszakításához.",
  insertAfter: (u) => `Beszúrás ${u.itemText} után`,
  insertBefore: (u) => `Beszúrás ${u.itemText} elé`,
  insertBetween: (u) => `Beszúrás ${u.beforeItemText} és ${u.afterItemText} közé`
};
var Vu = {};
Vu = {
  dragDescriptionKeyboard: "Premi Invio per iniziare a trascinare.",
  dragDescriptionKeyboardAlt: "Premi Alt + Invio per iniziare a trascinare.",
  dragDescriptionLongPress: "Premi a lungo per iniziare a trascinare.",
  dragDescriptionTouch: "Tocca due volte per iniziare a trascinare.",
  dragDescriptionVirtual: "Fai clic per iniziare a trascinare.",
  dragItem: (u) => `Trascina ${u.itemText}`,
  dragSelectedItems: (u, e) => `Trascina ${e.plural(u.count, {
    one: () => `${e.number(u.count)} altro elemento selezionato`,
    other: () => `${e.number(u.count)} altri elementi selezionati`
  })}`,
  dragSelectedKeyboard: (u, e) => `Premi Invio per trascinare ${e.plural(u.count, {
    one: () => `${e.number(u.count)} elemento selezionato`,
    other: () => `${e.number(u.count)} elementi selezionati`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Premi Alt + Invio per trascinare ${e.plural(u.count, {
    one: () => `${e.number(u.count)} elemento selezionato`,
    other: () => `${e.number(u.count)} elementi selezionati`
  })}.`,
  dragSelectedLongPress: (u, e) => `Premi a lungo per trascinare ${e.plural(u.count, {
    one: () => `${e.number(u.count)} elemento selezionato`,
    other: () => `${e.number(u.count)} elementi selezionati`
  })}.`,
  dragStartedKeyboard: "Hai iniziato a trascinare. Premi Tab per arrivare sull’area di destinazione, quindi premi Invio per rilasciare o Esc per annullare.",
  dragStartedTouch: "Hai iniziato a trascinare. Arriva sull’area di destinazione, quindi tocca due volte per rilasciare.",
  dragStartedVirtual: "Hai iniziato a trascinare. Arriva sull’area di destinazione, quindi fai clic o premi Invio per rilasciare.",
  dropCanceled: "Rilascio annullato.",
  dropComplete: "Rilascio completato.",
  dropDescriptionKeyboard: "Premi Invio per rilasciare. Premi Esc per annullare.",
  dropDescriptionTouch: "Tocca due volte per rilasciare.",
  dropDescriptionVirtual: "Fai clic per rilasciare.",
  dropIndicator: "indicatore di rilascio",
  dropOnItem: (u) => `Rilascia su ${u.itemText}`,
  dropOnRoot: "Rilascia su",
  endDragKeyboard: "Trascinamento. Premi Invio per annullare.",
  endDragTouch: "Trascinamento. Tocca due volte per annullare.",
  endDragVirtual: "Trascinamento. Fai clic per annullare.",
  insertAfter: (u) => `Inserisci dopo ${u.itemText}`,
  insertBefore: (u) => `Inserisci prima di ${u.itemText}`,
  insertBetween: (u) => `Inserisci tra ${u.beforeItemText} e ${u.afterItemText}`
};
var Lu = {};
Lu = {
  dragDescriptionKeyboard: "Enter キーを押してドラッグを開始してください。",
  dragDescriptionKeyboardAlt: "Alt+Enter キーを押してドラッグを開始します。",
  dragDescriptionLongPress: "長押ししてドラッグを開始します。",
  dragDescriptionTouch: "ダブルタップしてドラッグを開始します。",
  dragDescriptionVirtual: "クリックしてドラッグを開始します。",
  dragItem: (u) => `${u.itemText} をドラッグ`,
  dragSelectedItems: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)} 個の選択項目`,
    other: () => `${e.number(u.count)} 個の選択項目`
  })} をドラッグ`,
  dragSelectedKeyboard: (u, e) => `Enter キーを押して、${e.plural(u.count, {
    one: () => `${e.number(u.count)} 選択した項目`,
    other: () => `${e.number(u.count)} 選択した項目`
  })}をドラッグします。`,
  dragSelectedKeyboardAlt: (u, e) => `Alt+Enter キーを押して、${e.plural(u.count, {
    one: () => `${e.number(u.count)} 選択した項目`,
    other: () => `${e.number(u.count)} 選択した項目`
  })}をドラッグします。`,
  dragSelectedLongPress: (u, e) => `長押しして、${e.plural(u.count, {
    one: () => `${e.number(u.count)} 選択した項目`,
    other: () => `${e.number(u.count)} 選択した項目`
  })}をドラッグします。`,
  dragStartedKeyboard: "ドラッグを開始します。Tab キーを押してドロップターゲットにいどうし、Enter キーを押してドロップするか、Esc キーを押してキャンセルします。",
  dragStartedTouch: "ドラッグを開始しました。ドロップのターゲットに移動し、ダブルタップしてドロップします。",
  dragStartedVirtual: "ドラッグを開始しました。ドロップのターゲットに移動し、クリックまたは Enter キーを押してドロップします。",
  dropCanceled: "ドロップがキャンセルされました。",
  dropComplete: "ドロップが完了しました。",
  dropDescriptionKeyboard: "Enter キーを押してドロップします。Esc キーを押してドラッグをキャンセルします。",
  dropDescriptionTouch: "ダブルタップしてドロップします。",
  dropDescriptionVirtual: "クリックしてドロップします。",
  dropIndicator: "ドロップインジケーター",
  dropOnItem: (u) => `${u.itemText} にドロップ`,
  dropOnRoot: "ドロップ場所",
  endDragKeyboard: "ドラッグしています。Enter キーを押してドラッグをキャンセルします。",
  endDragTouch: "ドラッグしています。ダブルタップしてドラッグをキャンセルします。",
  endDragVirtual: "ドラッグしています。クリックしてドラッグをキャンセルします。",
  insertAfter: (u) => `${u.itemText} の後に挿入`,
  insertBefore: (u) => `${u.itemText} の前に挿入`,
  insertBetween: (u) => `${u.beforeItemText} と ${u.afterItemText} の間に挿入`
};
var Ru = {};
Ru = {
  dragDescriptionKeyboard: "드래그를 시작하려면 Enter를 누르세요.",
  dragDescriptionKeyboardAlt: "드래그를 시작하려면 Alt + Enter를 누르십시오.",
  dragDescriptionLongPress: "드래그를 시작하려면 길게 누르십시오.",
  dragDescriptionTouch: "드래그를 시작하려면 더블 탭하세요.",
  dragDescriptionVirtual: "드래그를 시작하려면 클릭하세요.",
  dragItem: (u) => `${u.itemText} 드래그`,
  dragSelectedItems: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)}개 선택 항목`,
    other: () => `${e.number(u.count)}개 선택 항목`
  })} 드래그`,
  dragSelectedKeyboard: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)}개 선택 항목`,
    other: () => `${e.number(u.count)}개 선택 항목`
  })}을 드래그하려면 Enter를 누르십시오.`,
  dragSelectedKeyboardAlt: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)}개 선택 항목`,
    other: () => `${e.number(u.count)}개 선택 항목`
  })}을 드래그하려면 Alt + Enter를 누르십시오.`,
  dragSelectedLongPress: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)}개 선택 항목`,
    other: () => `${e.number(u.count)}개 선택 항목`
  })}을 드래그하려면 길게 누르십시오.`,
  dragStartedKeyboard: "드래그가 시작되었습니다. Tab을 눌러 드롭 대상으로 이동한 다음 Enter를 눌러 드롭하거나 Esc를 눌러 취소하세요.",
  dragStartedTouch: "드래그가 시작되었습니다. 드롭 대상으로 이동한 다음 더블 탭하여 드롭하세요.",
  dragStartedVirtual: "드래그가 시작되었습니다. 드롭 대상으로 이동한 다음 클릭하거나 Enter를 눌러 드롭하세요.",
  dropCanceled: "드롭이 취소되었습니다.",
  dropComplete: "드롭이 완료되었습니다.",
  dropDescriptionKeyboard: "드롭하려면 Enter를 누르세요. 드래그를 취소하려면 Esc를 누르세요.",
  dropDescriptionTouch: "더블 탭하여 드롭하세요.",
  dropDescriptionVirtual: "드롭하려면 클릭하세요.",
  dropIndicator: "드롭 표시기",
  dropOnItem: (u) => `${u.itemText}에 드롭`,
  dropOnRoot: "드롭 대상",
  endDragKeyboard: "드래그 중입니다. 드래그를 취소하려면 Enter를 누르세요.",
  endDragTouch: "드래그 중입니다. 드래그를 취소하려면 더블 탭하세요.",
  endDragVirtual: "드래그 중입니다. 드래그를 취소하려면 클릭하세요.",
  insertAfter: (u) => `${u.itemText} 이후에 삽입`,
  insertBefore: (u) => `${u.itemText} 이전에 삽입`,
  insertBetween: (u) => `${u.beforeItemText} 및 ${u.afterItemText} 사이에 삽입`
};
var Ou = {};
Ou = {
  dragDescriptionKeyboard: "Paspauskite „Enter“, kad pradėtumėte vilkti.",
  dragDescriptionKeyboardAlt: "Paspauskite „Alt + Enter“, kad pradėtumėte vilkti.",
  dragDescriptionLongPress: "Palaikykite nuspaudę, kad pradėtumėte vilkti.",
  dragDescriptionTouch: "Palieskite dukart, kad pradėtumėte vilkti.",
  dragDescriptionVirtual: "Spustelėkite, kad pradėtumėte vilkti.",
  dragItem: (u) => `Vilkti ${u.itemText}`,
  dragSelectedItems: (u, e) => `Vilkti ${e.plural(u.count, {
    one: () => `${e.number(u.count)} pasirinktą elementą`,
    other: () => `${e.number(u.count)} pasirinktus elementus`
  })}`,
  dragSelectedKeyboard: (u, e) => `Paspauskite „Enter“, jei norite nuvilkti ${e.plural(u.count, {
    one: () => `${e.number(u.count)} pasirinktą elementą`,
    other: () => `${e.number(u.count)} pasirinktus elementus`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Paspauskite „Alt + Enter“, kad nuvilktumėte ${e.plural(u.count, {
    one: () => `${e.number(u.count)} pasirinktą elementą`,
    other: () => `${e.number(u.count)} pasirinktus elementus`
  })}.`,
  dragSelectedLongPress: (u, e) => `Nuspaudę palaikykite, kad nuvilktumėte ${e.plural(u.count, {
    one: () => `${e.number(u.count)} pasirinktą elementą`,
    other: () => `${e.number(u.count)} pasirinktus elementus`
  })}.`,
  dragStartedKeyboard: "Pradėta vilkti. Paspauskite „Tab“, kad pereitumėte į tiesioginę paskirties vietą, tada paspauskite „Enter“, kad numestumėte, arba „Escape“, kad atšauktumėte.",
  dragStartedTouch: "Pradėta vilkti. Eikite į tiesioginę paskirties vietą, tada palieskite dukart, kad numestumėte.",
  dragStartedVirtual: "Pradėta vilkti. Eikite į tiesioginę paskirties vietą ir spustelėkite arba paspauskite „Enter“, kad numestumėte.",
  dropCanceled: "Numetimas atšauktas.",
  dropComplete: "Numesta.",
  dropDescriptionKeyboard: "Paspauskite „Enter“, kad numestumėte. Paspauskite „Escape“, kad atšauktumėte vilkimą.",
  dropDescriptionTouch: "Palieskite dukart, kad numestumėte.",
  dropDescriptionVirtual: "Spustelėkite, kad numestumėte.",
  dropIndicator: "numetimo indikatorius",
  dropOnItem: (u) => `Numesti ant ${u.itemText}`,
  dropOnRoot: "Numesti ant",
  endDragKeyboard: "Velkama. Paspauskite „Enter“, kad atšauktumėte vilkimą.",
  endDragTouch: "Velkama. Spustelėkite dukart, kad atšauktumėte vilkimą.",
  endDragVirtual: "Velkama. Spustelėkite, kad atšauktumėte vilkimą.",
  insertAfter: (u) => `Įterpti po ${u.itemText}`,
  insertBefore: (u) => `Įterpti prieš ${u.itemText}`,
  insertBetween: (u) => `Įterpti tarp ${u.beforeItemText} ir ${u.afterItemText}`
};
var Nu = {};
Nu = {
  dragDescriptionKeyboard: "Nospiediet Enter, lai sāktu vilkšanu.",
  dragDescriptionKeyboardAlt: "Nospiediet taustiņu kombināciju Alt+Enter, lai sāktu vilkšanu.",
  dragDescriptionLongPress: "Turiet nospiestu, lai sāktu vilkšanu.",
  dragDescriptionTouch: "Veiciet dubultskārienu, lai sāktu vilkšanu.",
  dragDescriptionVirtual: "Noklikšķiniet, lai sāktu vilkšanu.",
  dragItem: (u) => `Velciet ${u.itemText}`,
  dragSelectedItems: (u, e) => `Velciet ${e.plural(u.count, {
    one: () => `${e.number(u.count)} atlasīto vienumu`,
    other: () => `${e.number(u.count)} atlasītos vienumus`
  })}`,
  dragSelectedKeyboard: (u, e) => `Nospiediet taustiņu Enter, lai vilktu ${e.plural(u.count, {
    one: () => `${e.number(u.count)} atlasīto vienumu`,
    other: () => `${e.number(u.count)} atlasītos vienumus`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Nospiediet taustiņu kombināciju Alt+Enter, lai vilktu ${e.plural(u.count, {
    one: () => `${e.number(u.count)} atlasīto vienumu`,
    other: () => `${e.number(u.count)} atlasītos vienumus`
  })}.`,
  dragSelectedLongPress: (u, e) => `Turiet nospiestu, lai vilktu ${e.plural(u.count, {
    one: () => `${e.number(u.count)} atlasīto vienumu`,
    other: () => `${e.number(u.count)} atlasītos vienumus`
  })}.`,
  dragStartedKeyboard: "Uzsākta vilkšana. Nospiediet taustiņu Tab, lai pārietu uz nomešanas mērķi, pēc tam nospiediet Enter, lai nomestu, vai nospiediet Escape, lai atceltu.",
  dragStartedTouch: "Uzsākta vilkšana. Pārejiet uz nomešanas mērķi, pēc tam veiciet dubultskārienu, lai nomestu.",
  dragStartedVirtual: "Uzsākta vilkšana. Pārejiet uz nomešanas mērķi, pēc tam nospiediet Enter, lai nomestu.",
  dropCanceled: "Nomešana atcelta.",
  dropComplete: "Nomešana pabeigta.",
  dropDescriptionKeyboard: "Nospiediet Enter, lai nomestu. Nospiediet Escape, lai atceltu vilkšanu.",
  dropDescriptionTouch: "Veiciet dubultskārienu, lai nomestu.",
  dropDescriptionVirtual: "Noklikšķiniet, lai nomestu.",
  dropIndicator: "nomešanas indikators",
  dropOnItem: (u) => `Nometiet uz ${u.itemText}`,
  dropOnRoot: "Nometiet uz",
  endDragKeyboard: "Notiek vilkšana. Nospiediet Enter, lai atceltu vilkšanu.",
  endDragTouch: "Notiek vilkšana. Veiciet dubultskārienu, lai atceltu vilkšanu.",
  endDragVirtual: "Notiek vilkšana. Noklikšķiniet, lai atceltu vilkšanu.",
  insertAfter: (u) => `Ievietojiet pēc ${u.itemText}`,
  insertBefore: (u) => `Ievietojiet pirms ${u.itemText}`,
  insertBetween: (u) => `Ievietojiet starp ${u.beforeItemText} un ${u.afterItemText}`
};
var Zu = {};
Zu = {
  dragDescriptionKeyboard: "Trykk på Enter for å begynne å dra.",
  dragDescriptionKeyboardAlt: "Trykk på Alt + Enter for å begynne å dra.",
  dragDescriptionLongPress: "Trykk lenge for å begynne å dra.",
  dragDescriptionTouch: "Dobbelttrykk for å begynne å dra.",
  dragDescriptionVirtual: "Klikk for å begynne å dra.",
  dragItem: (u) => `Dra ${u.itemText}`,
  dragSelectedItems: (u, e) => `Dra ${e.plural(u.count, {
    one: () => `${e.number(u.count)} merket element`,
    other: () => `${e.number(u.count)} merkede elementer`
  })}`,
  dragSelectedKeyboard: (u, e) => `Trykk Enter for å dra ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valgt element`,
    other: () => `${e.number(u.count)} valgte elementer`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Trykk på Alt + Enter for å dra ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valgt element`,
    other: () => `${e.number(u.count)} valgte elementer`
  })}.`,
  dragSelectedLongPress: (u, e) => `Trykk lenge for å dra ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valgt element`,
    other: () => `${e.number(u.count)} valgte elementer`
  })}.`,
  dragStartedKeyboard: "Begynte å dra. Trykk på Tab for å navigere til et mål, og trykk deretter på Enter for å slippe eller på Esc for å avbryte.",
  dragStartedTouch: "Begynte å dra. Naviger til et mål, og dobbelttrykk for å slippe.",
  dragStartedVirtual: "Begynte å dra. Naviger til et mål, og klikk eller trykk på Enter for å slippe.",
  dropCanceled: "Avbrøt slipping.",
  dropComplete: "Slippingen er fullført.",
  dropDescriptionKeyboard: "Trykk på Enter for å slippe. Trykk på Esc hvis du vil avbryte draingen.",
  dropDescriptionTouch: "Dobbelttrykk for å slippe.",
  dropDescriptionVirtual: "Klikk for å slippe.",
  dropIndicator: "slippeindikator",
  dropOnItem: (u) => `Slipp på ${u.itemText}`,
  dropOnRoot: "Slipp på",
  endDragKeyboard: "Drar. Trykk på Enter hvis du vil avbryte.",
  endDragTouch: "Drar. Dobbelttrykk hvis du vil avbryte.",
  endDragVirtual: "Drar. Klikk hvis du vil avbryte.",
  insertAfter: (u) => `Sett inn etter ${u.itemText}`,
  insertBefore: (u) => `Sett inn før ${u.itemText}`,
  insertBetween: (u) => `Sett inn mellom ${u.beforeItemText} og ${u.afterItemText}`
};
var Uu = {};
Uu = {
  dragDescriptionKeyboard: "Druk op Enter om te slepen.",
  dragDescriptionKeyboardAlt: "Druk op Alt + Enter om te slepen.",
  dragDescriptionLongPress: "Houd lang ingedrukt om te slepen.",
  dragDescriptionTouch: "Dubbeltik om te slepen.",
  dragDescriptionVirtual: "Klik om met slepen te starten.",
  dragItem: (u) => `${u.itemText} slepen`,
  dragSelectedItems: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)} geselecteerd item`,
    other: () => `${e.number(u.count)} geselecteerde items`
  })} slepen`,
  dragSelectedKeyboard: (u, e) => `Druk op Enter om ${e.plural(u.count, {
    one: () => `${e.number(u.count)} geselecteerd item`,
    other: () => `${e.number(u.count)} geselecteerde items`
  })} te slepen.`,
  dragSelectedKeyboardAlt: (u, e) => `Druk op Alt + Enter om ${e.plural(u.count, {
    one: () => `${e.number(u.count)} geselecteerd item`,
    other: () => `${e.number(u.count)} geselecteerde items`
  })} te slepen.`,
  dragSelectedLongPress: (u, e) => `Houd lang ingedrukt om ${e.plural(u.count, {
    one: () => `${e.number(u.count)} geselecteerd item`,
    other: () => `${e.number(u.count)} geselecteerde items`
  })} te slepen.`,
  dragStartedKeyboard: "Begonnen met slepen. Druk op Tab om naar een locatie te gaan. Druk dan op Enter om neer te zetten, of op Esc om te annuleren.",
  dragStartedTouch: "Begonnen met slepen. Ga naar de gewenste locatie en dubbeltik om neer te zetten.",
  dragStartedVirtual: "Begonnen met slepen. Ga naar de gewenste locatie en klik of druk op Enter om neer te zetten.",
  dropCanceled: "Neerzetten geannuleerd.",
  dropComplete: "Neerzetten voltooid.",
  dropDescriptionKeyboard: "Druk op Enter om neer te zetten. Druk op Esc om het slepen te annuleren.",
  dropDescriptionTouch: "Dubbeltik om neer te zetten.",
  dropDescriptionVirtual: "Klik om neer te zetten.",
  dropIndicator: "aanwijzer voor neerzetten",
  dropOnItem: (u) => `Neerzetten op ${u.itemText}`,
  dropOnRoot: "Neerzetten op",
  endDragKeyboard: "Bezig met slepen. Druk op Enter om te annuleren.",
  endDragTouch: "Bezig met slepen. Dubbeltik om te annuleren.",
  endDragVirtual: "Bezig met slepen. Klik om te annuleren.",
  insertAfter: (u) => `Plaatsen na ${u.itemText}`,
  insertBefore: (u) => `Plaatsen vóór ${u.itemText}`,
  insertBetween: (u) => `Plaatsen tussen ${u.beforeItemText} en ${u.afterItemText}`
};
var Mu = {};
Mu = {
  dragDescriptionKeyboard: "Naciśnij Enter, aby rozpocząć przeciąganie.",
  dragDescriptionKeyboardAlt: "Naciśnij Alt + Enter, aby rozpocząć przeciąganie.",
  dragDescriptionLongPress: "Naciśnij i przytrzymaj, aby rozpocząć przeciąganie.",
  dragDescriptionTouch: "Dotknij dwukrotnie, aby rozpocząć przeciąganie.",
  dragDescriptionVirtual: "Kliknij, aby rozpocząć przeciąganie.",
  dragItem: (u) => `Przeciągnij ${u.itemText}`,
  dragSelectedItems: (u, e) => `Przeciągnij ${e.plural(u.count, {
    one: () => `${e.number(u.count)} wybrany element`,
    other: () => `${e.number(u.count)} wybranych elementów`
  })}`,
  dragSelectedKeyboard: (u, e) => `Naciśnij Enter, aby przeciągnąć ${e.plural(u.count, {
    one: () => `${e.number(u.count)} wybrany element`,
    other: () => `${e.number(u.count)} wybrane(-ych) elementy(-ów)`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Naciśnij Alt + Enter, aby przeciągnąć ${e.plural(u.count, {
    one: () => `${e.number(u.count)} wybrany element`,
    other: () => `${e.number(u.count)} wybrane(-ych) elementy(-ów)`
  })}.`,
  dragSelectedLongPress: (u, e) => `Naciśnij i przytrzymaj, aby przeciągnąć ${e.plural(u.count, {
    one: () => `${e.number(u.count)} wybrany element`,
    other: () => `${e.number(u.count)} wybrane(-ych) elementy(-ów)`
  })}.`,
  dragStartedKeyboard: "Rozpoczęto przeciąganie. Naciśnij Tab, aby wybrać miejsce docelowe, a następnie naciśnij Enter, aby upuścić, lub Escape, aby anulować.",
  dragStartedTouch: "Rozpoczęto przeciąganie. Wybierz miejsce, w którym chcesz upuścić element, a następnie dotknij dwukrotnie, aby upuścić.F",
  dragStartedVirtual: "Rozpoczęto przeciąganie. Wybierz miejsce, w którym chcesz upuścić element, a następnie kliknij lub naciśnij Enter, aby upuścić.",
  dropCanceled: "Anulowano upuszczenie.",
  dropComplete: "Zakończono upuszczanie.",
  dropDescriptionKeyboard: "Naciśnij Enter, aby upuścić. Naciśnij Escape, aby anulować przeciągnięcie.",
  dropDescriptionTouch: "Dotknij dwukrotnie, aby upuścić.",
  dropDescriptionVirtual: "Kliknij, aby upuścić.",
  dropIndicator: "wskaźnik upuszczenia",
  dropOnItem: (u) => `Upuść na ${u.itemText}`,
  dropOnRoot: "Upuść",
  endDragKeyboard: "Przeciąganie. Naciśnij Enter, aby anulować przeciągnięcie.",
  endDragTouch: "Przeciąganie. Kliknij dwukrotnie, aby anulować przeciągnięcie.",
  endDragVirtual: "Przeciąganie. Kliknij, aby anulować przeciąganie.",
  insertAfter: (u) => `Umieść za ${u.itemText}`,
  insertBefore: (u) => `Umieść przed ${u.itemText}`,
  insertBetween: (u) => `Umieść między ${u.beforeItemText} i ${u.afterItemText}`
};
var qu = {};
qu = {
  dragDescriptionKeyboard: "Pressione Enter para começar a arrastar.",
  dragDescriptionKeyboardAlt: "Pressione Alt + Enter para começar a arrastar.",
  dragDescriptionLongPress: "Pressione e segure para começar a arrastar.",
  dragDescriptionTouch: "Toque duas vezes para começar a arrastar.",
  dragDescriptionVirtual: "Clique para começar a arrastar.",
  dragItem: (u) => `Arrastar ${u.itemText}`,
  dragSelectedItems: (u, e) => `Arrastar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} item selecionado`,
    other: () => `${e.number(u.count)} itens selecionados`
  })}`,
  dragSelectedKeyboard: (u, e) => `Pressione Enter para arrastar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} o item selecionado`,
    other: () => `${e.number(u.count)} os itens selecionados`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Pressione Alt + Enter para arrastar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} o item selecionado`,
    other: () => `${e.number(u.count)} os itens selecionados`
  })}.`,
  dragSelectedLongPress: (u, e) => `Pressione e segure para arrastar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} o item selecionado`,
    other: () => `${e.number(u.count)} os itens selecionados`
  })}.`,
  dragStartedKeyboard: "Comece a arrastar. Pressione Tab para navegar até um alvo e, em seguida, pressione Enter para soltar ou pressione Escape para cancelar.",
  dragStartedTouch: "Comece a arrastar. Navegue até um alvo e toque duas vezes para soltar.",
  dragStartedVirtual: "Comece a arrastar. Navegue até um alvo e clique ou pressione Enter para soltar.",
  dropCanceled: "Liberação cancelada.",
  dropComplete: "Liberação concluída.",
  dropDescriptionKeyboard: "Pressione Enter para soltar. Pressione Escape para cancelar.",
  dropDescriptionTouch: "Toque duas vezes para soltar.",
  dropDescriptionVirtual: "Clique para soltar.",
  dropIndicator: "indicador de liberação",
  dropOnItem: (u) => `Soltar em ${u.itemText}`,
  dropOnRoot: "Soltar",
  endDragKeyboard: "Arrastando. Pressione Enter para cancelar.",
  endDragTouch: "Arrastando. Toque duas vezes para cancelar.",
  endDragVirtual: "Arrastando. Clique para cancelar.",
  insertAfter: (u) => `Inserir após ${u.itemText}`,
  insertBefore: (u) => `Inserir antes de ${u.itemText}`,
  insertBetween: (u) => `Inserir entre ${u.beforeItemText} e ${u.afterItemText}`
};
var Hu = {};
Hu = {
  dragDescriptionKeyboard: "Prima Enter para iniciar o arrasto.",
  dragDescriptionKeyboardAlt: "Prima Alt + Enter para iniciar o arrasto.",
  dragDescriptionLongPress: "Prima longamente para começar a arrastar.",
  dragDescriptionTouch: "Faça duplo toque para começar a arrastar.",
  dragDescriptionVirtual: "Clique para iniciar o arrasto.",
  dragItem: (u) => `Arrastar ${u.itemText}`,
  dragSelectedItems: (u, e) => `Arrastar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} item selecionado`,
    other: () => `${e.number(u.count)} itens selecionados`
  })}`,
  dragSelectedKeyboard: (u, e) => `Prima Enter para arrastar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} o item selecionado`,
    other: () => `${e.number(u.count)} os itens selecionados`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Prima Alt + Enter para arrastar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} o item selecionado`,
    other: () => `${e.number(u.count)} os itens selecionados`
  })}.`,
  dragSelectedLongPress: (u, e) => `Prima longamente para arrastar ${e.plural(u.count, {
    one: () => `${e.number(u.count)} o item selecionado`,
    other: () => `${e.number(u.count)} os itens selecionados`
  })}.`,
  dragStartedKeyboard: "Arrasto iniciado. Prima a tecla de tabulação para navegar para um destino para largar, e em seguida prima Enter para largar ou prima Escape para cancelar.",
  dragStartedTouch: "Arrasto iniciado. Navegue para um destino para largar, e em seguida faça duplo toque para largar.",
  dragStartedVirtual: "Arrasto iniciado. Navegue para um destino para largar, e em seguida clique ou prima Enter para largar.",
  dropCanceled: "Largar cancelado.",
  dropComplete: "Largar completo.",
  dropDescriptionKeyboard: "Prima Enter para largar. Prima Escape para cancelar o arrasto.",
  dropDescriptionTouch: "Faça duplo toque para largar.",
  dropDescriptionVirtual: "Clique para largar.",
  dropIndicator: "Indicador de largar",
  dropOnItem: (u) => `Largar em ${u.itemText}`,
  dropOnRoot: "Largar em",
  endDragKeyboard: "A arrastar. Prima Enter para cancelar o arrasto.",
  endDragTouch: "A arrastar. Faça duplo toque para cancelar o arrasto.",
  endDragVirtual: "A arrastar. Clique para cancelar o arrasto.",
  insertAfter: (u) => `Inserir depois de ${u.itemText}`,
  insertBefore: (u) => `Inserir antes de ${u.itemText}`,
  insertBetween: (u) => `Inserir entre ${u.beforeItemText} e ${u.afterItemText}`
};
var Gu = {};
Gu = {
  dragDescriptionKeyboard: "Apăsați pe Enter pentru a începe glisarea.",
  dragDescriptionKeyboardAlt: "Apăsați pe Alt + Enter pentru a începe glisarea.",
  dragDescriptionLongPress: "Apăsați lung pentru a începe glisarea.",
  dragDescriptionTouch: "Atingeți de două ori pentru a începe să glisați.",
  dragDescriptionVirtual: "Faceți clic pentru a începe glisarea.",
  dragItem: (u) => `Glisați ${u.itemText}`,
  dragSelectedItems: (u, e) => `Glisați ${e.plural(u.count, {
    one: () => `${e.number(u.count)} element selectat`,
    other: () => `${e.number(u.count)} elemente selectate`
  })}`,
  dragSelectedKeyboard: (u, e) => `Apăsați pe Enter pentru a glisa ${e.plural(u.count, {
    one: () => `${e.number(u.count)} element selectat`,
    other: () => `${e.number(u.count)} elemente selectate`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Apăsați pe Alt + Enter pentru a glisa ${e.plural(u.count, {
    one: () => `${e.number(u.count)} element selectat`,
    other: () => `${e.number(u.count)} elemente selectate`
  })}.`,
  dragSelectedLongPress: (u, e) => `Apăsați lung pentru a glisa ${e.plural(u.count, {
    one: () => `${e.number(u.count)} element selectat`,
    other: () => `${e.number(u.count)} elemente selectate`
  })}.`,
  dragStartedKeyboard: "A început glisarea. Apăsați pe Tab pentru a naviga la o țintă de fixare, apoi apăsați pe Enter pentru a fixa sau apăsați pe Escape pentru a anula glisarea.",
  dragStartedTouch: "A început glisarea. Navigați la o țintă de fixare, apoi atingeți de două ori pentru a fixa.",
  dragStartedVirtual: "A început glisarea. Navigați la o țintă de fixare, apoi faceți clic sau apăsați pe Enter pentru a fixa.",
  dropCanceled: "Fixare anulată.",
  dropComplete: "Fixare finalizată.",
  dropDescriptionKeyboard: "Apăsați pe Enter pentru a fixa. Apăsați pe Escape pentru a anula glisarea.",
  dropDescriptionTouch: "Atingeți de două ori pentru a fixa.",
  dropDescriptionVirtual: "Faceți clic pentru a fixa.",
  dropIndicator: "indicator de fixare",
  dropOnItem: (u) => `Fixați pe ${u.itemText}`,
  dropOnRoot: "Fixare pe",
  endDragKeyboard: "Se glisează. Apăsați pe Enter pentru a anula glisarea.",
  endDragTouch: "Se glisează. Atingeți de două ori pentru a anula glisarea.",
  endDragVirtual: "Se glisează. Faceți clic pentru a anula glisarea.",
  insertAfter: (u) => `Inserați după ${u.itemText}`,
  insertBefore: (u) => `Inserați înainte de ${u.itemText}`,
  insertBetween: (u) => `Inserați între ${u.beforeItemText} și ${u.afterItemText}`
};
var _u = {};
_u = {
  dragDescriptionKeyboard: "Нажмите клавишу Enter для начала перетаскивания.",
  dragDescriptionKeyboardAlt: "Нажмите Alt + Enter, чтобы начать перетаскивать.",
  dragDescriptionLongPress: "Нажмите и удерживайте, чтобы начать перетаскивать.",
  dragDescriptionTouch: "Дважды нажмите для начала перетаскивания.",
  dragDescriptionVirtual: "Щелкните для начала перетаскивания.",
  dragItem: (u) => `Перетащить ${u.itemText}`,
  dragSelectedItems: (u, e) => `Перетащить ${e.plural(u.count, {
    one: () => `${e.number(u.count)} выбранный элемент`,
    other: () => `${e.number(u.count)} выбранных элем`
  })}`,
  dragSelectedKeyboard: (u, e) => `Нажмите Enter для перетаскивания ${e.plural(u.count, {
    one: () => `${e.number(u.count)} выбранного элемента`,
    other: () => `${e.number(u.count)} выбранных элементов`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Нажмите Alt + Enter для перетаскивания ${e.plural(u.count, {
    one: () => `${e.number(u.count)} выбранного элемента`,
    other: () => `${e.number(u.count)} выбранных элементов`
  })}.`,
  dragSelectedLongPress: (u, e) => `Нажмите и удерживайте для перетаскивания ${e.plural(u.count, {
    one: () => `${e.number(u.count)} выбранного элемента`,
    other: () => `${e.number(u.count)} выбранных элементов`
  })}.`,
  dragStartedKeyboard: "Начато перетаскивание. Нажмите клавишу Tab для выбора цели, затем нажмите клавишу Enter, чтобы применить перетаскивание, или клавишу Escape для отмены действия.",
  dragStartedTouch: "Начато перетаскивание. Выберите цель, затем дважды нажмите, чтобы применить перетаскивание.",
  dragStartedVirtual: "Начато перетаскивание. Нажмите клавишу Tab для выбора цели, затем нажмите клавишу Enter, чтобы применить перетаскивание.",
  dropCanceled: "Перетаскивание отменено.",
  dropComplete: "Перетаскивание завершено.",
  dropDescriptionKeyboard: "Нажмите клавишу Enter, чтобы применить перетаскивание. Нажмите клавишу Escape для отмены.",
  dropDescriptionTouch: "Дважды нажмите, чтобы применить перетаскивание.",
  dropDescriptionVirtual: "Щелкните, чтобы применить перетаскивание.",
  dropIndicator: "индикатор перетаскивания",
  dropOnItem: (u) => `Перетащить на ${u.itemText}`,
  dropOnRoot: "Перетащить на",
  endDragKeyboard: "Перетаскивание. Нажмите клавишу Enter для отмены.",
  endDragTouch: "Перетаскивание. Дважды нажмите для отмены.",
  endDragVirtual: "Перетаскивание. Щелкните для отмены.",
  insertAfter: (u) => `Вставить после ${u.itemText}`,
  insertBefore: (u) => `Вставить перед ${u.itemText}`,
  insertBetween: (u) => `Вставить между ${u.beforeItemText} и ${u.afterItemText}`
};
var Wu = {};
Wu = {
  dragDescriptionKeyboard: "Stlačením klávesu Enter začnete presúvanie.",
  dragDescriptionKeyboardAlt: "Stlačením klávesov Alt + Enter začnete presúvanie.",
  dragDescriptionLongPress: "Dlhým stlačením začnete presúvanie.",
  dragDescriptionTouch: "Dvojitým kliknutím začnete presúvanie.",
  dragDescriptionVirtual: "Kliknutím začnete presúvanie.",
  dragItem: (u) => `Presunúť položku ${u.itemText}`,
  dragSelectedItems: (u, e) => `Presunúť ${e.plural(u.count, {
    one: () => `${e.number(u.count)} vybratú položku`,
    other: () => `${e.number(u.count)} vybraté položky`
  })}`,
  dragSelectedKeyboard: (u, e) => `Stlačením klávesu Enter presuniete ${e.plural(u.count, {
    one: () => `${e.number(u.count)} vybratú položku`,
    other: () => `${e.number(u.count)} vybratých položiek`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Stlačením klávesov Alt + Enter presuniete ${e.plural(u.count, {
    one: () => `${e.number(u.count)} vybratú položku`,
    other: () => `${e.number(u.count)} vybratých položiek`
  })}.`,
  dragSelectedLongPress: (u, e) => `Dlhým stlačením presuniete ${e.plural(u.count, {
    one: () => `${e.number(u.count)} vybratú položku`,
    other: () => `${e.number(u.count)} vybratých položiek`
  })}.`,
  dragStartedKeyboard: "Presúvanie sa začalo. Do cieľového umiestnenia prejdete stlačením klávesu Tab. Ak chcete položku umiestniť, stlačte kláves Enter alebo stlačte kláves Esc, ak chcete presúvanie zrušiť.",
  dragStartedTouch: "Presúvanie sa začalo. Prejdite na cieľové umiestnenie a dvojitým kliknutím umiestnite položku.",
  dragStartedVirtual: "Presúvanie sa začalo. Prejdite na cieľové umiestnenie a kliknutím alebo stlačením klávesu Enter umiestnite položku.",
  dropCanceled: "Umiestnenie zrušené.",
  dropComplete: "Umiestnenie dokončené.",
  dropDescriptionKeyboard: "Stlačením klávesu Enter umiestnite položku. Stlačením klávesu Esc zrušíte presúvanie.",
  dropDescriptionTouch: "Dvojitým kliknutím umiestnite položku.",
  dropDescriptionVirtual: "Kliknutím umiestnite položku.",
  dropIndicator: "indikátor umiestnenia",
  dropOnItem: (u) => `Umiestniť na položku ${u.itemText}`,
  dropOnRoot: "Umiestniť na",
  endDragKeyboard: "Prebieha presúvanie. Ak ho chcete zrušiť, stlačte kláves Enter.",
  endDragTouch: "Prebieha presúvanie. Dvojitým kliknutím ho môžete zrušiť.",
  endDragVirtual: "Prebieha presúvanie.",
  insertAfter: (u) => `Vložiť za položku ${u.itemText}`,
  insertBefore: (u) => `Vložiť pred položku ${u.itemText}`,
  insertBetween: (u) => `Vložiť medzi položky ${u.beforeItemText} a ${u.afterItemText}`
};
var Yu = {};
Yu = {
  dragDescriptionKeyboard: "Pritisnite tipko Enter za začetek vlečenja.",
  dragDescriptionKeyboardAlt: "Pritisnite tipki Alt + Enter za začetek vlečenja.",
  dragDescriptionLongPress: "Pritisnite in zadržite za začetek vlečenja.",
  dragDescriptionTouch: "Dvotapnite za začetek vlečenja.",
  dragDescriptionVirtual: "Kliknite za začetek vlečenja.",
  dragItem: (u) => `Povleci ${u.itemText}`,
  dragSelectedItems: (u, e) => `Povlecite ${e.plural(u.count, {
    one: () => `${e.number(u.count)} izbran element`,
    other: () => `izbrane elemente (${e.number(u.count)})`
  })}`,
  dragSelectedKeyboard: (u, e) => `Pritisnite tipko Enter, da povlečete ${e.plural(u.count, {
    one: () => `${e.number(u.count)} izbrani element`,
    other: () => `${e.number(u.count)} izbranih elementov`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Pritisnite tipki Alt + Enter, da povlečete ${e.plural(u.count, {
    one: () => `${e.number(u.count)} izbrani element`,
    other: () => `${e.number(u.count)} izbranih elementov`
  })}.`,
  dragSelectedLongPress: (u, e) => `Pritisnite in zadržite, da povlečete ${e.plural(u.count, {
    one: () => `${e.number(u.count)} izbrani element`,
    other: () => `${e.number(u.count)} izbranih elementov`
  })}.`,
  dragStartedKeyboard: "Vlečenje se je začelo. Pritisnite tipko Tab za pomik na mesto, kamor želite spustiti elemente, in pritisnite tipko Enter, da jih spustite, ali tipko Escape, da prekličete postopek.",
  dragStartedTouch: "Vlečenje se je začelo. Pomaknite se na mesto, kamor želite spustiti elemente, in dvotapnite, da jih spustite.",
  dragStartedVirtual: "Vlečenje se je začelo. Pomaknite se na mesto, kamor želite spustiti elemente, in kliknite ali pritisnite tipko Enter, da jih spustite.",
  dropCanceled: "Spust je preklican.",
  dropComplete: "Spust je končan.",
  dropDescriptionKeyboard: "Pritisnite tipko Enter, da spustite. Pritisnite tipko Escape, da prekličete vlečenje.",
  dropDescriptionTouch: "Dvotapnite, da spustite.",
  dropDescriptionVirtual: "Kliknite, da spustite.",
  dropIndicator: "indikator spusta",
  dropOnItem: (u) => `Spusti na mesto ${u.itemText}`,
  dropOnRoot: "Spusti na mesto",
  endDragKeyboard: "Vlečenje. Pritisnite tipko Enter za preklic vlečenja.",
  endDragTouch: "Vlečenje. Dvotapnite za preklic vlečenja.",
  endDragVirtual: "Vlečenje. Kliknite, da prekličete vlečenje.",
  insertAfter: (u) => `Vstavi za ${u.itemText}`,
  insertBefore: (u) => `Vstavi pred ${u.itemText}`,
  insertBetween: (u) => `Vstavi med ${u.beforeItemText} in ${u.afterItemText}`
};
var Xu = {};
Xu = {
  dragDescriptionKeyboard: "Pritisnite Enter da biste započeli prevlačenje.",
  dragDescriptionKeyboardAlt: "Pritisnite Alt + Enter da biste započeli prevlačenje.",
  dragDescriptionLongPress: "Pritisnite dugo da biste započeli prevlačenje.",
  dragDescriptionTouch: "Dvaput dodirnite da biste započeli prevlačenje.",
  dragDescriptionVirtual: "Kliknite da biste započeli prevlačenje.",
  dragItem: (u) => `Prevucite ${u.itemText}`,
  dragSelectedItems: (u, e) => `Prevucite ${e.plural(u.count, {
    one: () => `${e.number(u.count)} izabranu stavku`,
    other: () => `${e.number(u.count)} izabrane stavke`
  })}`,
  dragSelectedKeyboard: (u, e) => `Pritisnite Enter da biste prevukli ${e.plural(u.count, {
    one: () => `${e.number(u.count)} izabranu stavku`,
    other: () => `${e.number(u.count)} izabranih stavki`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Pritisnite Alt + Enter da biste prevukli ${e.plural(u.count, {
    one: () => `${e.number(u.count)} izabranu stavku`,
    other: () => `${e.number(u.count)} izabranih stavki`
  })}.`,
  dragSelectedLongPress: (u, e) => `Pritisnite dugo da biste prevukli ${e.plural(u.count, {
    one: () => `${e.number(u.count)} izabranu stavku`,
    other: () => `${e.number(u.count)} izabranih stavki`
  })}.`,
  dragStartedKeyboard: "Prevlačenje je započeto. Pritisnite Tab da biste otišli do cilja za otpuštanje, zatim pritisnite Enter za ispuštanje ili pritisnite Escape za otkazivanje.",
  dragStartedTouch: "Prevlačenje je započeto. Idite do cilja za otpuštanje, a zatim dvaput dodirnite za otpuštanje.",
  dragStartedVirtual: "Prevlačenje je započeto. Idite do cilja za otpuštanje, a zatim kliknite ili pritinite Enter za otpuštanje.",
  dropCanceled: "Otpuštanje je otkazano.",
  dropComplete: "Prevlačenje je završeno.",
  dropDescriptionKeyboard: "Pritisnite Enter da biste otpustili. Pritisnite Escape da biste otkazali prevlačenje.",
  dropDescriptionTouch: "Dvaput dodirnite za otpuštanje.",
  dropDescriptionVirtual: "Kliknite za otpuštanje.",
  dropIndicator: "Indikator otpuštanja",
  dropOnItem: (u) => `Otpusti na ${u.itemText}`,
  dropOnRoot: "Otpusti na",
  endDragKeyboard: "Prevlačenje u toku. Pritisnite Enter da biste otkazali prevlačenje.",
  endDragTouch: "Prevlačenje u toku. Dvaput dodirnite da biste otkazali prevlačenje.",
  endDragVirtual: "Prevlačenje u toku. Kliknite da biste otkazali prevlačenje.",
  insertAfter: (u) => `Umetnite posle ${u.itemText}`,
  insertBefore: (u) => `Umetnite ispred ${u.itemText}`,
  insertBetween: (u) => `Umetnite između ${u.beforeItemText} i ${u.afterItemText}`
};
var Ju = {};
Ju = {
  dragDescriptionKeyboard: "Tryck på enter för att börja dra.",
  dragDescriptionKeyboardAlt: "Tryck på Alt + Retur för att börja dra.",
  dragDescriptionLongPress: "Tryck länge för att börja dra.",
  dragDescriptionTouch: "Dubbeltryck för att börja dra.",
  dragDescriptionVirtual: "Klicka för att börja dra.",
  dragItem: (u) => `Dra ${u.itemText}`,
  dragSelectedItems: (u, e) => `Dra ${e.plural(u.count, {
    one: () => `${e.number(u.count)} valt objekt`,
    other: () => `${e.number(u.count)} valda objekt`
  })}`,
  dragSelectedKeyboard: (u, e) => `Tryck på Retur för att dra ${e.plural(u.count, {
    one: () => `${e.number(u.count)} markerat objekt`,
    other: () => `${e.number(u.count)} markerade objekt`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Tryck på Alt + Retur för att dra ${e.plural(u.count, {
    one: () => `${e.number(u.count)} markerat objekt`,
    other: () => `${e.number(u.count)} markerade objekt`
  })}.`,
  dragSelectedLongPress: (u, e) => `Tryck länge för att dra ${e.plural(u.count, {
    one: () => `${e.number(u.count)} markerat objekt`,
    other: () => `${e.number(u.count)} markerade objekt`
  })}.`,
  dragStartedKeyboard: "Börja dra. Tryck på tabb för att navigera till målet, tryck på enter för att släppa eller på escape för att avbryta.",
  dragStartedTouch: "Börja dra. Navigera till ett mål och dubbeltryck för att släppa.",
  dragStartedVirtual: "Börja dra. Navigera till ett mål och klicka eller tryck på enter för att släppa.",
  dropCanceled: "Släppåtgärd avbröts.",
  dropComplete: "Släppåtgärd klar.",
  dropDescriptionKeyboard: "Tryck på enter för att släppa. Tryck på escape för att avbryta dragåtgärd.",
  dropDescriptionTouch: "Dubbeltryck för att släppa.",
  dropDescriptionVirtual: "Klicka för att släppa.",
  dropIndicator: "släppindikator",
  dropOnItem: (u) => `Släpp på ${u.itemText}`,
  dropOnRoot: "Släpp på",
  endDragKeyboard: "Drar. Tryck på enter för att avbryta dragåtgärd.",
  endDragTouch: "Drar. Dubbeltryck för att avbryta dragåtgärd.",
  endDragVirtual: "Drar. Klicka för att avbryta dragåtgärd.",
  insertAfter: (u) => `Infoga efter ${u.itemText}`,
  insertBefore: (u) => `Infoga före ${u.itemText}`,
  insertBetween: (u) => `Infoga mellan ${u.beforeItemText} och ${u.afterItemText}`
};
var Qu = {};
Qu = {
  dragDescriptionKeyboard: "Sürüklemeyi başlatmak için Enter'a basın.",
  dragDescriptionKeyboardAlt: "Sürüklemeyi başlatmak için Alt + Enter'a basın.",
  dragDescriptionLongPress: "Sürüklemeye başlamak için uzun basın.",
  dragDescriptionTouch: "Sürüklemeyi başlatmak için çift tıklayın.",
  dragDescriptionVirtual: "Sürüklemeyi başlatmak için tıklayın.",
  dragItem: (u) => `${u.itemText}’i sürükle`,
  dragSelectedItems: (u, e) => `Sürükle ${e.plural(u.count, {
    one: () => `${e.number(u.count)} seçili öge`,
    other: () => `${e.number(u.count)} seçili öge`
  })}`,
  dragSelectedKeyboard: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)} seçilmiş öğe`,
    other: () => `${e.number(u.count)} seçilmiş öğe`
  })} öğesini sürüklemek için Enter'a basın.`,
  dragSelectedKeyboardAlt: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)} seçilmiş öğe`,
    other: () => `${e.number(u.count)} seçilmiş öğe`
  })} öğesini sürüklemek için Alt + Enter tuşuna basın.`,
  dragSelectedLongPress: (u, e) => `${e.plural(u.count, {
    one: () => `${e.number(u.count)} seçilmiş öğe`,
    other: () => `${e.number(u.count)} seçilmiş öğe`
  })} öğesini sürüklemek için uzun basın.`,
  dragStartedKeyboard: "Sürükleme başlatıldı. Bir bırakma hedefine gitmek için Tab’a basın, ardından bırakmak için Enter’a basın veya iptal etmek için Escape’e basın.",
  dragStartedTouch: "Sürükleme başlatıldı. Bir bırakma hedefine gidin, ardından bırakmak için çift tıklayın.",
  dragStartedVirtual: "Sürükleme başlatıldı. Bir bırakma hedefine gidin, ardından bırakmak için Enter’a tıklayın veya basın.",
  dropCanceled: "Bırakma iptal edildi.",
  dropComplete: "Bırakma tamamlandı.",
  dropDescriptionKeyboard: "Bırakmak için Enter'a basın. Sürüklemeyi iptal etmek için Escape'e basın.",
  dropDescriptionTouch: "Bırakmak için çift tıklayın.",
  dropDescriptionVirtual: "Bırakmak için tıklayın.",
  dropIndicator: "bırakma göstergesi",
  dropOnItem: (u) => `${u.itemText} üzerine bırak`,
  dropOnRoot: "Bırakın",
  endDragKeyboard: "Sürükleme. Sürüklemeyi iptal etmek için Enter'a basın.",
  endDragTouch: "Sürükleme. Sürüklemeyi iptal etmek için çift tıklayın.",
  endDragVirtual: "Sürükleme. Sürüklemeyi iptal etmek için tıklayın.",
  insertAfter: (u) => `${u.itemText}’den sonra gir`,
  insertBefore: (u) => `${u.itemText}’den önce gir`,
  insertBetween: (u) => `${u.beforeItemText} ve ${u.afterItemText} arasına gir`
};
var ue = {};
ue = {
  dragDescriptionKeyboard: "Натисніть Enter, щоб почати перетягування.",
  dragDescriptionKeyboardAlt: "Натисніть Alt + Enter, щоб почати перетягування.",
  dragDescriptionLongPress: "Натисніть і утримуйте, щоб почати перетягування.",
  dragDescriptionTouch: "Натисніть двічі, щоб почати перетягування.",
  dragDescriptionVirtual: "Натисніть, щоб почати перетягування.",
  dragItem: (u) => `Перетягнути ${u.itemText}`,
  dragSelectedItems: (u, e) => `Перетягніть ${e.plural(u.count, {
    one: () => `${e.number(u.count)} вибраний елемент`,
    other: () => `${e.number(u.count)} вибраних елем`
  })}`,
  dragSelectedKeyboard: (u, e) => `Натисніть Enter, щоб перетягнути ${e.plural(u.count, {
    one: () => `${e.number(u.count)} вибраний елемент`,
    other: () => `${e.number(u.count)} вибраних елементи(-ів)`
  })}.`,
  dragSelectedKeyboardAlt: (u, e) => `Натисніть Alt + Enter, щоб перетягнути ${e.plural(u.count, {
    one: () => `${e.number(u.count)} вибраний елемент`,
    other: () => `${e.number(u.count)} вибраних елементи(-ів)`
  })}.`,
  dragSelectedLongPress: (u, e) => `Утримуйте, щоб перетягнути ${e.plural(u.count, {
    one: () => `${e.number(u.count)} вибраний елемент`,
    other: () => `${e.number(u.count)} вибраних елементи(-ів)`
  })}.`,
  dragStartedKeyboard: "Перетягування почалося. Натисніть Tab, щоб перейти до цілі перетягування, потім натисніть Enter, щоб перетягнути, або Escape, щоб скасувати.",
  dragStartedTouch: "Перетягування почалося. Перейдіть до цілі перетягування, потім натисніть двічі, щоб перетягнути.",
  dragStartedVirtual: "Перетягування почалося. Перейдіть до цілі перетягування, потім натисніть Enter, щоб перетягнути.",
  dropCanceled: "Перетягування скасовано.",
  dropComplete: "Перетягування завершено.",
  dropDescriptionKeyboard: "Натисніть Enter, щоб перетягнути. Натисніть Escape, щоб скасувати перетягування.",
  dropDescriptionTouch: "Натисніть двічі, щоб перетягнути.",
  dropDescriptionVirtual: "Натисніть, щоб перетягнути.",
  dropIndicator: "індикатор перетягування",
  dropOnItem: (u) => `Перетягнути на ${u.itemText}`,
  dropOnRoot: "Перетягнути на",
  endDragKeyboard: "Триває перетягування. Натисніть Enter, щоб скасувати перетягування.",
  endDragTouch: "Триває перетягування. Натисніть двічі, щоб скасувати перетягування.",
  endDragVirtual: "Триває перетягування. Натисніть, щоб скасувати перетягування.",
  insertAfter: (u) => `Вставити після ${u.itemText}`,
  insertBefore: (u) => `Вставити перед ${u.itemText}`,
  insertBetween: (u) => `Вставити між ${u.beforeItemText} і ${u.afterItemText}`
};
var ee = {};
ee = {
  dragDescriptionKeyboard: "按 Enter 开始拖动。",
  dragDescriptionKeyboardAlt: "按 Alt + Enter 开始拖动。",
  dragDescriptionLongPress: "长按以开始拖动。",
  dragDescriptionTouch: "双击开始拖动。",
  dragDescriptionVirtual: "单击开始拖动。",
  dragItem: (u) => `拖动 ${u.itemText}`,
  dragSelectedItems: (u, e) => `拖动 ${e.plural(u.count, {
    one: () => `${e.number(u.count)} 选中项目`,
    other: () => `${e.number(u.count)} 选中项目`
  })}`,
  dragSelectedKeyboard: (u, e) => `按 Enter 以拖动 ${e.plural(u.count, {
    one: () => `${e.number(u.count)} 个选定项`,
    other: () => `${e.number(u.count)} 个选定项`
  })}。`,
  dragSelectedKeyboardAlt: (u, e) => `按 Alt + Enter 以拖动 ${e.plural(u.count, {
    one: () => `${e.number(u.count)} 个选定项`,
    other: () => `${e.number(u.count)} 个选定项`
  })}。`,
  dragSelectedLongPress: (u, e) => `长按以拖动 ${e.plural(u.count, {
    one: () => `${e.number(u.count)} 个选定项`,
    other: () => `${e.number(u.count)} 个选定项`
  })}。`,
  dragStartedKeyboard: "已开始拖动。按 Tab 导航到放置目标，然后按 Enter 放置或按 Escape 取消。",
  dragStartedTouch: "已开始拖动。导航到放置目标，然后双击放置。",
  dragStartedVirtual: "已开始拖动。导航到放置目标，然后单击或按 Enter 放置。",
  dropCanceled: "放置已取消。",
  dropComplete: "放置已完成。",
  dropDescriptionKeyboard: "按 Enter 放置。按 Escape 取消拖动。",
  dropDescriptionTouch: "双击放置。",
  dropDescriptionVirtual: "单击放置。",
  dropIndicator: "放置标记",
  dropOnItem: (u) => `放置于 ${u.itemText}`,
  dropOnRoot: "放置于",
  endDragKeyboard: "正在拖动。按 Enter 取消拖动。",
  endDragTouch: "正在拖动。双击取消拖动。",
  endDragVirtual: "正在拖动。单击取消拖动。",
  insertAfter: (u) => `插入到 ${u.itemText} 之后`,
  insertBefore: (u) => `插入到 ${u.itemText} 之前`,
  insertBetween: (u) => `插入到 ${u.beforeItemText} 和 ${u.afterItemText} 之间`
};
var te = {};
te = {
  dragDescriptionKeyboard: "按 Enter 鍵以開始拖曳。",
  dragDescriptionKeyboardAlt: "按 Alt+Enter 鍵以開始拖曳。",
  dragDescriptionLongPress: "長按以開始拖曳。",
  dragDescriptionTouch: "輕點兩下以開始拖曳。",
  dragDescriptionVirtual: "按一下滑鼠以開始拖曳。",
  dragItem: (u) => `拖曳「${u.itemText}」`,
  dragSelectedItems: (u, e) => `拖曳 ${e.plural(u.count, {
    one: () => `${e.number(u.count)} 個選定項目`,
    other: () => `${e.number(u.count)} 個選定項目`
  })}`,
  dragSelectedKeyboard: (u, e) => `按 Enter 鍵以拖曳 ${e.plural(u.count, {
    one: () => `${e.number(u.count)} 個選定項目`,
    other: () => `${e.number(u.count)} 個選定項目`
  })}。`,
  dragSelectedKeyboardAlt: (u, e) => `按 Alt+Enter 鍵以拖曳 ${e.plural(u.count, {
    one: () => `${e.number(u.count)} 個選定項目`,
    other: () => `${e.number(u.count)} 個選定項目`
  })}。`,
  dragSelectedLongPress: (u, e) => `長按以拖曳 ${e.plural(u.count, {
    one: () => `${e.number(u.count)} 個選定項目`,
    other: () => `${e.number(u.count)} 個選定項目`
  })}。`,
  dragStartedKeyboard: "已開始拖曳。按 Tab 鍵以瀏覽至放置目標，然後按 Enter 鍵以放置，或按 Escape 鍵以取消。",
  dragStartedTouch: "已開始拖曳。瀏覽至放置目標，然後輕點兩下以放置。",
  dragStartedVirtual: "已開始拖曳。瀏覽至放置目標，然後按一下滑鼠或按 Enter 鍵以放置。",
  dropCanceled: "放置已取消。",
  dropComplete: "放置已完成。",
  dropDescriptionKeyboard: "按 Enter 鍵以放置。按 Escape 鍵以取消拖曳。",
  dropDescriptionTouch: "輕點兩下以放置。",
  dropDescriptionVirtual: "按一下滑鼠以放置。",
  dropIndicator: "放置指示器",
  dropOnItem: (u) => `放置在「${u.itemText}」上`,
  dropOnRoot: "放置在",
  endDragKeyboard: "拖曳中。按 Enter 鍵以取消拖曳。",
  endDragTouch: "拖曳中。輕點兩下以取消拖曳。",
  endDragVirtual: "拖曳中。按一下滑鼠以取消拖曳。",
  insertAfter: (u) => `插入至「${u.itemText}」之後`,
  insertBefore: (u) => `插入至「${u.itemText}」之前`,
  insertBetween: (u) => `插入至「${u.beforeItemText}」和「${u.afterItemText}」之間`
};
var re = {};
re = {
  "ar-AE": ku,
  "bg-BG": Au,
  "cs-CZ": hu,
  "da-DK": yu,
  "de-DE": vu,
  "el-GR": Fu,
  "en-US": Tu,
  "es-ES": zu,
  "et-EE": Su,
  "fi-FI": Pu,
  "fr-FR": Ku,
  "he-IL": Iu,
  "hr-HR": ju,
  "hu-HU": wu,
  "it-IT": Vu,
  "ja-JP": Lu,
  "ko-KR": Ru,
  "lt-LT": Ou,
  "lv-LV": Nu,
  "nb-NO": Zu,
  "nl-NL": Uu,
  "pl-PL": Mu,
  "pt-BR": qu,
  "pt-PT": Hu,
  "ro-RO": Gu,
  "ru-RU": _u,
  "sk-SK": Wu,
  "sl-SI": Yu,
  "sr-SP": Xu,
  "sv-SE": Ju,
  "tr-TR": Qu,
  "uk-UA": ue,
  "zh-CN": ee,
  "zh-TW": te
};
function N4(u) {
  return u && u.__esModule ? u.default : u;
}
const Z4 = {
  keyboard: "dropDescriptionKeyboard",
  touch: "dropDescriptionTouch",
  virtual: "dropDescriptionVirtual"
};
function U4() {
  let u = bu(N4(re), "@react-aria/dnd"), e = I4(), t = O4();
  return {
    dropProps: {
      ...c4(t ? u.format(Z4[e]) : ""),
      // Mobile Safari does not properly bubble click events on elements except links or inputs
      // unless there is an onclick handler bound directly to the element itself. By adding this
      // handler, React will take care of adding that for us, and we are able to handle document
      // level click events in the DragManager.
      // See https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
      onClick: () => {
      }
    }
  };
}
const M4 = 800;
function q4(u) {
  let { hasDropButton: e, isDisabled: t } = u, [r, n] = z(!1), a = W({
    x: 0,
    y: 0,
    dragOverElements: /* @__PURE__ */ new Set(),
    dropEffect: "none",
    allowedOperations: E.all,
    dropActivateTimer: void 0
  }).current, d = (o) => {
    if (n(!0), typeof u.onDropEnter == "function") {
      let l = o.currentTarget.getBoundingClientRect();
      u.onDropEnter({
        type: "dropenter",
        x: o.clientX - l.x,
        y: o.clientY - l.y
      });
    }
  }, s = (o) => {
    if (n(!1), typeof u.onDropExit == "function") {
      let l = o.currentTarget.getBoundingClientRect();
      u.onDropExit({
        type: "dropexit",
        x: o.clientX - l.x,
        y: o.clientY - l.y
      });
    }
  }, B = (o) => {
    o.preventDefault(), o.stopPropagation();
    let l = su(o);
    if (o.clientX === a.x && o.clientY === a.y && l === a.allowedOperations) {
      o.dataTransfer.dropEffect = a.dropEffect;
      return;
    }
    a.x = o.clientX, a.y = o.clientY;
    let x = a.dropEffect;
    if (l !== a.allowedOperations) {
      let p = U(l), D = p[0];
      if (typeof u.getDropOperation == "function") {
        let C = new I(o.dataTransfer);
        D = j(l, u.getDropOperation(C, p));
      }
      a.dropEffect = Z[D] || "none";
    }
    if (typeof u.getDropOperationForPoint == "function") {
      let p = new I(o.dataTransfer), D = o.currentTarget.getBoundingClientRect(), C = j(l, u.getDropOperationForPoint(p, U(l), a.x - D.x, a.y - D.y));
      a.dropEffect = Z[C] || "none";
    }
    if (a.allowedOperations = l, o.dataTransfer.dropEffect = a.dropEffect, a.dropEffect === "none" && x !== "none" ? s(o) : a.dropEffect !== "none" && x === "none" && d(o), typeof u.onDropMove == "function" && a.dropEffect !== "none") {
      let p = o.currentTarget.getBoundingClientRect();
      u.onDropMove({
        type: "dropmove",
        x: a.x - p.x,
        y: a.y - p.y
      });
    }
    if (clearTimeout(a.dropActivateTimer), u.onDropActivate && typeof u.onDropActivate == "function" && a.dropEffect !== "none") {
      let p = u.onDropActivate, D = o.currentTarget.getBoundingClientRect();
      a.dropActivateTimer = setTimeout(() => {
        p({
          type: "dropactivate",
          x: a.x - D.x,
          y: a.y - D.y
        });
      }, M4);
    }
  }, c = (o) => {
    if (o.preventDefault(), o.stopPropagation(), a.dragOverElements.add(o.target), a.dragOverElements.size > 1) return;
    let l = su(o), x = U(l), p = x[0];
    if (typeof u.getDropOperation == "function") {
      let D = new I(o.dataTransfer);
      p = j(l, u.getDropOperation(D, x));
    }
    if (typeof u.getDropOperationForPoint == "function") {
      let D = new I(o.dataTransfer), C = o.currentTarget.getBoundingClientRect();
      p = j(l, u.getDropOperationForPoint(D, x, o.clientX - C.x, o.clientY - C.y));
    }
    a.x = o.clientX, a.y = o.clientY, a.allowedOperations = l, a.dropEffect = Z[p] || "none", o.dataTransfer.dropEffect = a.dropEffect, p !== "cancel" && d(o);
  }, i = (o) => {
    o.preventDefault(), o.stopPropagation(), a.dragOverElements.delete(o.target);
    for (let l of a.dragOverElements) o.currentTarget.contains(l) || a.dragOverElements.delete(l);
    a.dragOverElements.size > 0 || (a.dropEffect !== "none" && s(o), clearTimeout(a.dropActivateTimer));
  }, b = (o) => {
    if (o.preventDefault(), o.stopPropagation(), a.dropEffect, typeof u.onDrop == "function") {
      let x = mu[a.dropEffect], p = $u(o.dataTransfer), D = o.currentTarget.getBoundingClientRect(), C = {
        type: "drop",
        x: o.clientX - D.x,
        y: o.clientY - D.y,
        items: p,
        dropOperation: x
      };
      u.onDrop(C);
    }
    let l = {
      ...fu
    };
    a.dragOverElements.clear(), s(o), clearTimeout(a.dropActivateTimer), l.draggingCollectionRef == null || L4(l);
  }, A = m((o) => {
    typeof u.onDropEnter == "function" && u.onDropEnter(o);
  }), h = m((o) => {
    typeof u.onDropExit == "function" && u.onDropExit(o);
  }), S = m((o) => {
    typeof u.onDropActivate == "function" && u.onDropActivate(o);
  }), y = m((o) => {
    typeof u.onDrop == "function" && u.onDrop(o);
  }), P = m((o, l) => u.getDropOperation ? u.getDropOperation(o, l) : l[0]), { ref: v } = u;
  pu(() => {
    if (!(t || !v.current))
      return R4({
        element: v.current,
        getDropOperation: P,
        onDropEnter(o) {
          n(!0), A(o);
        },
        onDropExit(o) {
          n(!1), h(o);
        },
        onDrop: y,
        onDropActivate: S
      });
  }, [
    t,
    v,
    P,
    A,
    h,
    y,
    S
  ]);
  let { dropProps: K } = U4();
  return t ? {
    dropProps: {},
    dropButtonProps: {
      isDisabled: !0
    },
    isDropTarget: !1
  } : {
    dropProps: {
      ...!e && K,
      onDragEnter: c,
      onDragOver: B,
      onDragLeave: i,
      onDrop: b
    },
    dropButtonProps: {
      ...e && K
    },
    isDropTarget: r
  };
}
function su(u) {
  let e = xu[u.dataTransfer.effectAllowed];
  iu && (e &= iu);
  let t = E.none;
  return Ue() ? (u.altKey && (t |= E.copy), u.ctrlKey && !Me() && (t |= E.link), u.metaKey && (t |= E.move)) : (u.altKey && (t |= E.link), u.shiftKey && (t |= E.move), u.ctrlKey && (t |= E.copy)), t ? e & t : e;
}
function U(u) {
  let e = [];
  return u & E.move && e.push("move"), u & E.copy && e.push("copy"), u & E.link && e.push("link"), e;
}
function j(u, e) {
  let t = E[e];
  return u & t ? e : "cancel";
}
const M = /* @__PURE__ */ new Map();
function f(u, e) {
  let t = M.get(u);
  if (!t) {
    let r = /* @__PURE__ */ new Set(), n = (a) => {
      for (let d of r) d(a);
    };
    t = {
      listener: n,
      handlers: r
    }, M.set(u, t), document.addEventListener(u, n);
  }
  return t.handlers.add(e), () => {
    t.handlers.delete(e), t.handlers.size === 0 && (document.removeEventListener(u, t.listener), M.delete(u));
  };
}
function H4(u) {
  let { isDisabled: e } = u, t = W(!1), { focusProps: r } = qe({
    onFocusChange: (i) => {
      t.current = i;
    }
  }), n = m((i) => {
    t.current && u.getItems && i.preventDefault();
  }), a = m((i) => {
    if (!(!t.current || !u.getItems) && (i.preventDefault(), i.clipboardData)) {
      var b;
      ou(i.clipboardData, u.getItems()), (b = u.onCopy) === null || b === void 0 || b.call(u);
    }
  }), d = m((i) => {
    t.current && u.onCut && u.getItems && i.preventDefault();
  }), s = m((i) => {
    !t.current || !u.onCut || !u.getItems || (i.preventDefault(), i.clipboardData && (ou(i.clipboardData, u.getItems()), u.onCut()));
  }), B = m((i) => {
    t.current && u.onPaste && i.preventDefault();
  }), c = m((i) => {
    if (!(!t.current || !u.onPaste) && (i.preventDefault(), i.clipboardData)) {
      let b = $u(i.clipboardData);
      u.onPaste(b);
    }
  });
  return _(() => {
    if (!e)
      return He(f("beforecopy", n), f("copy", a), f("beforecut", d), f("cut", s), f("beforepaste", B), f("paste", c));
  }, [
    e,
    n,
    a,
    d,
    s,
    B,
    c
  ]), {
    clipboardProps: r
  };
}
const G4 = /* @__PURE__ */ Bu({});
var ae = {};
ae = {
  colorSwatchPicker: "تغييرات الألوان",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "حدد عنصرًا",
  tableResizer: "أداة تغيير الحجم"
};
var ne = {};
ne = {
  colorSwatchPicker: "Цветови мостри",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Изберете предмет",
  tableResizer: "Преоразмерител"
};
var oe = {};
oe = {
  colorSwatchPicker: "Vzorky barev",
  dropzoneLabel: "Místo pro přetažení",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Změna velikosti"
};
var ie = {};
ie = {
  colorSwatchPicker: "Farveprøver",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vælg et element",
  tableResizer: "Størrelsesændring"
};
var le = {};
le = {
  colorSwatchPicker: "Farbfelder",
  dropzoneLabel: "Ablegebereich",
  selectPlaceholder: "Element wählen",
  tableResizer: "Größenanpassung"
};
var de = {};
de = {
  colorSwatchPicker: "Χρωματικά δείγματα",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Επιλέξτε ένα αντικείμενο",
  tableResizer: "Αλλαγή μεγέθους"
};
var ce = {};
ce = {
  selectPlaceholder: "Select an item",
  tableResizer: "Resizer",
  dropzoneLabel: "DropZone",
  colorSwatchPicker: "Color swatches"
};
var se = {};
se = {
  colorSwatchPicker: "Muestras de colores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Seleccionar un artículo",
  tableResizer: "Cambiador de tamaño"
};
var pe = {};
pe = {
  colorSwatchPicker: "Värvinäidised",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valige üksus",
  tableResizer: "Suuruse muutja"
};
var De = {};
De = {
  colorSwatchPicker: "Värimallit",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valitse kohde",
  tableResizer: "Koon muuttaja"
};
var Be = {};
Be = {
  colorSwatchPicker: "Échantillons de couleurs",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Sélectionner un élément",
  tableResizer: "Redimensionneur"
};
var Ce = {};
Ce = {
  colorSwatchPicker: "דוגמיות צבע",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "בחר פריט",
  tableResizer: "שינוי גודל"
};
var Ee = {};
Ee = {
  colorSwatchPicker: "Uzorci boja",
  dropzoneLabel: "Zona spuštanja",
  selectPlaceholder: "Odaberite stavku",
  tableResizer: "Promjena veličine"
};
var be = {};
be = {
  colorSwatchPicker: "Színtárak",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Válasszon ki egy elemet",
  tableResizer: "Átméretező"
};
var xe = {};
xe = {
  colorSwatchPicker: "Campioni di colore",
  dropzoneLabel: "Zona di rilascio",
  selectPlaceholder: "Seleziona un elemento",
  tableResizer: "Ridimensionamento"
};
var me = {};
me = {
  colorSwatchPicker: "カラースウォッチ",
  dropzoneLabel: "ドロップゾーン",
  selectPlaceholder: "項目を選択",
  tableResizer: "サイズ変更ツール"
};
var $e = {};
$e = {
  colorSwatchPicker: "색상 견본",
  dropzoneLabel: "드롭 영역",
  selectPlaceholder: "항목 선택",
  tableResizer: "크기 조정기"
};
var ge = {};
ge = {
  colorSwatchPicker: "Spalvų pavyzdžiai",
  dropzoneLabel: "„DropZone“",
  selectPlaceholder: "Pasirinkite elementą",
  tableResizer: "Dydžio keitiklis"
};
var fe = {};
fe = {
  colorSwatchPicker: "Krāsu paraugi",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izvēlēties vienumu",
  tableResizer: "Izmēra mainītājs"
};
var ke = {};
ke = {
  colorSwatchPicker: "Fargekart",
  dropzoneLabel: "Droppsone",
  selectPlaceholder: "Velg et element",
  tableResizer: "Størrelsesendrer"
};
var Ae = {};
Ae = {
  colorSwatchPicker: "kleurstalen",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecteer een item",
  tableResizer: "Resizer"
};
var he = {};
he = {
  colorSwatchPicker: "Próbki kolorów",
  dropzoneLabel: "Strefa upuszczania",
  selectPlaceholder: "Wybierz element",
  tableResizer: "Zmiana rozmiaru"
};
var ye = {};
ye = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var ve = {};
ve = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var Fe = {};
Fe = {
  colorSwatchPicker: "Specimene de culoare",
  dropzoneLabel: "Zonă de plasare",
  selectPlaceholder: "Selectați un element",
  tableResizer: "Instrument de redimensionare"
};
var Te = {};
Te = {
  colorSwatchPicker: "Цветовые образцы",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Выберите элемент",
  tableResizer: "Средство изменения размера"
};
var ze = {};
ze = {
  colorSwatchPicker: "Vzorkovníky farieb",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Nástroj na zmenu veľkosti"
};
var Se = {};
Se = {
  colorSwatchPicker: "Barvne palete",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izberite element",
  tableResizer: "Spreminjanje velikosti"
};
var Pe = {};
Pe = {
  colorSwatchPicker: "Uzorci boje",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izaberite stavku",
  tableResizer: "Promena veličine"
};
var Ke = {};
Ke = {
  colorSwatchPicker: "Färgrutor",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Välj en artikel",
  tableResizer: "Storleksändrare"
};
var Ie = {};
Ie = {
  colorSwatchPicker: "Renk örnekleri",
  dropzoneLabel: "Bırakma Bölgesi",
  selectPlaceholder: "Bir öğe seçin",
  tableResizer: "Yeniden boyutlandırıcı"
};
var je = {};
je = {
  colorSwatchPicker: "Зразки кольорів",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Виберіть елемент",
  tableResizer: "Засіб змінення розміру"
};
var we = {};
we = {
  colorSwatchPicker: "颜色色板",
  dropzoneLabel: "放置区域",
  selectPlaceholder: "选择一个项目",
  tableResizer: "尺寸调整器"
};
var Ve = {};
Ve = {
  colorSwatchPicker: "色票",
  dropzoneLabel: "放置區",
  selectPlaceholder: "選取項目",
  tableResizer: "大小調整器"
};
var Le = {};
Le = {
  "ar-AE": ae,
  "bg-BG": ne,
  "cs-CZ": oe,
  "da-DK": ie,
  "de-DE": le,
  "el-GR": de,
  "en-US": ce,
  "es-ES": se,
  "et-EE": pe,
  "fi-FI": De,
  "fr-FR": Be,
  "he-IL": Ce,
  "hr-HR": Ee,
  "hu-HU": be,
  "it-IT": xe,
  "ja-JP": me,
  "ko-KR": $e,
  "lt-LT": ge,
  "lv-LV": fe,
  "nb-NO": ke,
  "nl-NL": Ae,
  "pl-PL": he,
  "pt-BR": ye,
  "pt-PT": ve,
  "ro-RO": Fe,
  "ru-RU": Te,
  "sk-SK": ze,
  "sl-SI": Se,
  "sr-SP": Pe,
  "sv-SE": Ke,
  "tr-TR": Ie,
  "uk-UA": je,
  "zh-CN": we,
  "zh-TW": Ve
};
function _4(u) {
  return u && u.__esModule ? u.default : u;
}
const W4 = /* @__PURE__ */ Bu(null);
function Y4(u, e) {
  let { isDisabled: t = !1 } = u;
  [u, e] = Ge(u, e, W4);
  let r = _e(e), n = W(null), { dropProps: a, dropButtonProps: d, isDropTarget: s } = q4({
    ...u,
    ref: n,
    hasDropButton: !0
  }), { buttonProps: B } = We(d || {}, n), { hoverProps: c, isHovered: i } = Ye(u), { focusProps: b, isFocused: A, isFocusVisible: h } = Xe(), S = bu(_4(Le), "react-aria-components"), y = Je(), P = u["aria-label"] || S.format("dropzoneLabel"), v = u["aria-labelledby"], K = [
    y,
    v
  ].filter(Boolean).join(" "), o = l4({
    "aria-label": P,
    "aria-labelledby": K
  }), { clipboardProps: l } = H4({
    isDisabled: t,
    onPaste: (D) => {
      var C;
      return (C = u.onDrop) === null || C === void 0 ? void 0 : C.call(u, {
        type: "drop",
        items: D,
        x: 0,
        y: 0,
        dropOperation: "copy"
      });
    }
  }), x = Qe({
    ...u,
    values: {
      isHovered: i,
      isFocused: A,
      isFocusVisible: h,
      isDropTarget: s,
      isDisabled: t
    },
    defaultClassName: "react-aria-DropZone"
  }), p = u4(u);
  return delete p.id, /* @__PURE__ */ k.createElement(e4, {
    values: [
      [
        G4,
        {
          id: y,
          slot: "label"
        }
      ]
    ]
  }, /* @__PURE__ */ k.createElement("div", {
    ...q(a, c, p),
    ...x,
    slot: u.slot || void 0,
    ref: r,
    onClick: (D) => {
      var C;
      let $ = D.target;
      for (; $ && (!((C = r.current) === null || C === void 0) && C.contains($)) && !p4($); ) {
        if ($ === r.current) {
          var O;
          (O = n.current) === null || O === void 0 || O.focus();
          break;
        }
        $ = $.parentElement;
      }
    },
    "data-hovered": i || void 0,
    "data-focused": A || void 0,
    "data-focus-visible": h || void 0,
    "data-drop-target": s || void 0,
    "data-disabled": t || void 0
  }, /* @__PURE__ */ k.createElement(T4, null, /* @__PURE__ */ k.createElement("button", {
    ...q(B, b, l, o),
    ref: n
  })), x.children));
}
const X4 = /* @__PURE__ */ n4(Y4), J4 = "_wrapper_naeg2_1", Q4 = "_dropZone_naeg2_7", ut = "_linearGradientMove_naeg2_1", et = "_glow_naeg2_1", tt = "_uploadTarget_naeg2_42", rt = "_messageTopRow_naeg2_81", w = {
  wrapper: J4,
  dropZone: Q4,
  linearGradientMove: ut,
  glow: et,
  uploadTarget: tt,
  messageTopRow: rt
}, ct = ({
  className: u,
  setFile: e,
  setFiles: t,
  allowedMimeTypes: r = [],
  title: n = "Drop files here or click to browse",
  subtitle: a = "Supported file types are .pdf, .png, and .jpeg.",
  icon: d = o4.upload,
  name: s
}) => /* @__PURE__ */ F("div", { className: i4(w.wrapper, u), children: /* @__PURE__ */ F(
  X4,
  {
    className: w.dropZone,
    getDropOperation: (B) => r.length === 0 || // allow all if not specified
    r.some((c) => B.has(c)) ? "copy" : "cancel",
    onDrop: async (B) => {
      const c = B.items.filter(
        (i) => i.kind === "file" && (r.length === 0 || // allow all if not specified
        r.includes(i.type))
      );
      if (c.length !== 0) {
        if (e) {
          const i = await c[0].getFile();
          e(i);
        }
        if (t) {
          const i = await Promise.all(
            c.map((b) => b.getFile())
          );
          t(i);
        }
      }
    },
    children: /* @__PURE__ */ F(
      t4,
      {
        acceptedFileTypes: r.length === 0 ? void 0 : r,
        onSelect: async (B) => {
          const c = Array.from(B ?? []);
          c.length !== 0 && (e == null || e(c[0]), t == null || t(c));
        },
        allowsMultiple: !!t,
        children: /* @__PURE__ */ J(r4, { className: w.uploadTarget, name: s, children: [
          /* @__PURE__ */ J("div", { className: w.messageTopRow, children: [
            d,
            /* @__PURE__ */ F(Q, { color: "nextGreyscale800", size: "16px", children: n })
          ] }),
          /* @__PURE__ */ F(Q, { color: "nextGreyscale800", size: "14px", children: a })
        ] })
      }
    )
  }
) });
export {
  ct as FileUpload
};
